export const fetchStaticData = [
  
{
    "artist": {
      "pK_ArtistId": 1,
      "artistName": "Dino Pacifici",
      "artistLocation": "Montreal, Québec",
      "artistBio": "Dino Frank Pacifici was born in Montreal, Canada, on July 20, 1958.  He began his musical studies at a very early age of 5 years old, concentrating on classical guitar. Dino started composing at the age of 13. In 1982 he received his Bachelor's Degree in Fine Arts (music) from Concordia University.  \r\n\r\nDino is that consummate artist whose sound and gift is grounded in ambient/chillout music with a jazz influence in combination with his own unique identity. Over the years Dino has kept busy writing Pop-Oriented and Dance music and playing in local bands. Dino has spent many years studying, recording, and performing live in which he continuously expands his musical horizons. Dino has become proficient with bass, keyboards, programming of electronic instruments, as well as his first love the guitar. His compositions including recordings of ambient/space and chillout/jazz albums. \r\n\r\nIn 1979, Dino's first independent album, ‘Become a Man’ (NAB Records) was released locally, and received radio air play for two years. Three years later, his single release of ‘Jana's Song’ receives local air play.\r\n\r\nIn 1986 he co-wrote NANCY MARTINEZ's 'hit'' single on the ‘Not Just The Girl Next Door’ album entitled ‘Move Out’ (Atlantic Records).\r\n\r\nIn 1994, Dino released ‘Random Factors’ which is a mix of different styles from Smooth jazz to ambient to experimental. \r\n\r\nIn 1997, ‘The Journey’ was released, which began Dino’s adventure into recording ambient/space compositions.\r\n\r\nCurrently, Dino has successfully recorded over 40 albums, EPs and singles, cascading many genres, which include Smooth Jazz, Ambient, Space, Chill-Out, Rock, Pop-Oriented and Dance.  Dino is continuously expanding his creative nature with the addition of various instruments and technology while recording.\r\n\r\nIn 2025 Dino became a Wayfarer Music Group recording artist and continues to release solo recordings, as well as collaborative efforts, along side artists Brannan Lane, Theresa Bentley and Daniel Löwen.\r\n\r\nPresently, Dino divides his time with his love for his family, being a musician, photography and a massage therapist.\r\n\r\nThe journey continues….\r\n\r\n~ September 2026 ~",
      "artistInformation": "Dino Pacifici, A musician and composer from Montreal, Canada. Maecenas iaculis interdum sodales. Phasellus a fermentum elit. Duis et libero sed lorem hendrerit ullamcorper. Morbi dapibus sed lacus quis pretium. Nunc pharetra finibus nisi vitae rutrum. Donec nulla diam, interdum sed sagittis in, aliquam ac ipsum. Nunc facilisis ex et velit tempor laoreet. Aenean vitae urna mollis, ultrices nisi quis, vestibulum tellus. Maecenas est magna, dapibus ut feugiat et, ornare ac nibh. Quisque lobortis quam feugiat massa laoreet, sed efficitur massa finibus. Donec vulputate in nunc eu condimentum. Praesent sollicitudin euismod sollicitudin. Aenean dui erat, blandit quis cursus vel, dignissim eget nulla. Duis vestibulum enim vitae nunc luctus cursus. Pellentesque id ipsum nisi.",
      "artistImage": "DinoPacifici.jpg",
      "artistLatestReleaseInformation": "Dino Pacifici's latest featured collaboration album, 'The Continuum Experience', was released on Wayfarer Records on September 12th, 2026."
    },
    "artistFeaturedAlbum": {
      "pK_AlbumId": 44,
      "fK_ArtistId": 1,
      "albumTitle": "The Continuum Experience",
      "albumImageCover": "Dino_Pacifici_The_Continuum_Experience.jpg",
      "albumImageBack": null,
      "albumLength": "00:38:00",
      "albumStory": "It was a great pleasure working with electronic musician, Daniel Löwen on this project. It was a symbiotic relationship that was very satisfying and positive. Enjoy the music:)",
      "albumInformation": null,
      "albumCopyright": "2026",
      "albumCopyrightDescription": "Wayfarer Records",
      "albumGenres": "Ambient, Ambient Chill, Electronic, Instrumental, Pop, Spa, Montreal",
      "albumFriendlyUrl": "Continuum-Experience",
      "albumSortOrder": 5,
      "albumReleaseDate": "2026-09-12T00:00:00",
      "tracks": [
        {
          "pK_TrackId": 339,
          "fK_AlbumId": 44,
          "trackNumber": 1,
          "trackTitle": "The Pillars Of Hercules",
          "trackMP3": "DinoPacifici-TheContinuumExperience-01-ThePillarsOfHercules.mp3",
          "trackLength": "00:04:02",
          "trackDescription": null
        },
        {
          "pK_TrackId": 340,
          "fK_AlbumId": 44,
          "trackNumber": 2,
          "trackTitle": "The Continuum Experience",
          "trackMP3": "DinoPacifici-TheContinuumExperience-02-TheContinuumExperience.mp3",
          "trackLength": "00:04:50",
          "trackDescription": null
        },
        {
          "pK_TrackId": 341,
          "fK_AlbumId": 44,
          "trackNumber": 3,
          "trackTitle": "Forest Lullaby",
          "trackMP3": "DinoPacifici-TheContinuumExperience-03-ForestLullaby.mp3",
          "trackLength": "00:04:14",
          "trackDescription": null
        },
        {
          "pK_TrackId": 342,
          "fK_AlbumId": 44,
          "trackNumber": 4,
          "trackTitle": "A Colour Of Hearts",
          "trackMP3": "DinoPacifici-TheContinuumExperience-04-AColourOfHearts.mp3",
          "trackLength": "00:03:50",
          "trackDescription": null
        },
        {
          "pK_TrackId": 343,
          "fK_AlbumId": 44,
          "trackNumber": 5,
          "trackTitle": "The Eye Of Trust",
          "trackMP3": "DinoPacifici-TheContinuumExperience-05-TheEyeOfTrust.mp3",
          "trackLength": "00:04:02",
          "trackDescription": null
        },
        {
          "pK_TrackId": 344,
          "fK_AlbumId": 44,
          "trackNumber": 6,
          "trackTitle": "Sleep In Her Eyes",
          "trackMP3": "DinoPacifici-TheContinuumExperience-06-SleepInHerEyes.mp3",
          "trackLength": "00:06:02",
          "trackDescription": null
        },
        {
          "pK_TrackId": 345,
          "fK_AlbumId": 44,
          "trackNumber": 7,
          "trackTitle": "In The Shadow Of Olympia",
          "trackMP3": "DinoPacifici-TheContinuumExperience-07-InTheShadowOfOlympia.mp3",
          "trackLength": "00:03:04",
          "trackDescription": null
        },
        {
          "pK_TrackId": 346,
          "fK_AlbumId": 44,
          "trackNumber": 8,
          "trackTitle": "Deja-Vu",
          "trackMP3": "DinoPacifici-TheContinuumExperience-08-Deja-Vu.mp3",
          "trackLength": "00:04:41",
          "trackDescription": null
        },
        {
          "pK_TrackId": 347,
          "fK_AlbumId": 44,
          "trackNumber": 9,
          "trackTitle": "Velvet Road",
          "trackMP3": "DinoPacifici-TheContinuumExperience-09-VelvetRoad.mp3",
          "trackLength": "00:03:10",
          "trackDescription": null
        }
      ],
      "buyAts": [
        {
          "pK_BuyAtId": 51,
          "fK_AlbumId": 44,
          "linkSiteName": "BandCamp - Dino Pacifici",
          "linkUrl": "https://dinopacifici.bandcamp.com/album/the-continuum-experience-daniel-l-wen-and-dino-pacifici",
          "linkLabel": "BandCamp",
          "linkIcon": null,
          "linkOrder": 1,
          "linkShow": true
        },
        {
          "pK_BuyAtId": 52,
          "fK_AlbumId": 44,
          "linkSiteName": "BandCamp - Wayfarer",
          "linkUrl": "https://wayfarermusicgroup.bandcamp.com/album/the-continuum-experience",
          "linkLabel": "BandCamp",
          "linkIcon": null,
          "linkOrder": 2,
          "linkShow": true
        }
      ],
      "featuredAlbum": true,
      "showOnWebsite": true
    },
    "artistAlbums": [
      {
        "pK_AlbumId": 44,
        "fK_ArtistId": 1,
        "albumTitle": "The Continuum Experience",
        "albumImageCover": "Dino_Pacifici_The_Continuum_Experience.jpg",
        "albumImageBack": null,
        "albumLength": "00:38:00",
        "albumStory": "It was a great pleasure working with electronic musician, Daniel Löwen on this project. It was a symbiotic relationship that was very satisfying and positive. Enjoy the music:)",
        "albumInformation": null,
        "albumCopyright": "2026",
        "albumCopyrightDescription": "Wayfarer Records",
        "albumGenres": "Ambient, Ambient Chill, Electronic, Instrumental, Pop, Spa, Montreal",
        "albumFriendlyUrl": "Continuum-Experience",
        "albumSortOrder": 5,
        "albumReleaseDate": "2026-09-12T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 339,
            "fK_AlbumId": 44,
            "trackNumber": 1,
            "trackTitle": "The Pillars Of Hercules",
            "trackMP3": "DinoPacifici-TheContinuumExperience-01-ThePillarsOfHercules.mp3",
            "trackLength": "00:04:02",
            "trackDescription": null
          },
          {
            "pK_TrackId": 340,
            "fK_AlbumId": 44,
            "trackNumber": 2,
            "trackTitle": "The Continuum Experience",
            "trackMP3": "DinoPacifici-TheContinuumExperience-02-TheContinuumExperience.mp3",
            "trackLength": "00:04:50",
            "trackDescription": null
          },
          {
            "pK_TrackId": 341,
            "fK_AlbumId": 44,
            "trackNumber": 3,
            "trackTitle": "Forest Lullaby",
            "trackMP3": "DinoPacifici-TheContinuumExperience-03-ForestLullaby.mp3",
            "trackLength": "00:04:14",
            "trackDescription": null
          },
          {
            "pK_TrackId": 342,
            "fK_AlbumId": 44,
            "trackNumber": 4,
            "trackTitle": "A Colour Of Hearts",
            "trackMP3": "DinoPacifici-TheContinuumExperience-04-AColourOfHearts.mp3",
            "trackLength": "00:03:50",
            "trackDescription": null
          },
          {
            "pK_TrackId": 343,
            "fK_AlbumId": 44,
            "trackNumber": 5,
            "trackTitle": "The Eye Of Trust",
            "trackMP3": "DinoPacifici-TheContinuumExperience-05-TheEyeOfTrust.mp3",
            "trackLength": "00:04:02",
            "trackDescription": null
          },
          {
            "pK_TrackId": 344,
            "fK_AlbumId": 44,
            "trackNumber": 6,
            "trackTitle": "Sleep In Her Eyes",
            "trackMP3": "DinoPacifici-TheContinuumExperience-06-SleepInHerEyes.mp3",
            "trackLength": "00:06:02",
            "trackDescription": null
          },
          {
            "pK_TrackId": 345,
            "fK_AlbumId": 44,
            "trackNumber": 7,
            "trackTitle": "In The Shadow Of Olympia",
            "trackMP3": "DinoPacifici-TheContinuumExperience-07-InTheShadowOfOlympia.mp3",
            "trackLength": "00:03:04",
            "trackDescription": null
          },
          {
            "pK_TrackId": 346,
            "fK_AlbumId": 44,
            "trackNumber": 8,
            "trackTitle": "Deja-Vu",
            "trackMP3": "DinoPacifici-TheContinuumExperience-08-Deja-Vu.mp3",
            "trackLength": "00:04:41",
            "trackDescription": null
          },
          {
            "pK_TrackId": 347,
            "fK_AlbumId": 44,
            "trackNumber": 9,
            "trackTitle": "Velvet Road",
            "trackMP3": "DinoPacifici-TheContinuumExperience-09-VelvetRoad.mp3",
            "trackLength": "00:03:10",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 51,
            "fK_AlbumId": 44,
            "linkSiteName": "BandCamp - Dino Pacifici",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/the-continuum-experience-daniel-l-wen-and-dino-pacifici",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          },
          {
            "pK_BuyAtId": 52,
            "fK_AlbumId": 44,
            "linkSiteName": "BandCamp - Wayfarer",
            "linkUrl": "https://wayfarermusicgroup.bandcamp.com/album/the-continuum-experience",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 2,
            "linkShow": true
          }
        ],
        "featuredAlbum": true,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 43,
        "fK_ArtistId": 1,
        "albumTitle": "Electrophonix",
        "albumImageCover": "Dino_Pacifici_Electrophonix.jpg",
        "albumImageBack": null,
        "albumLength": "00:58:29",
        "albumStory": null,
        "albumInformation": "Composed, performed, mixed and mastered by: Dino Pacifici © 2026 Scorpio Rising Music.\r\n\r\nCover: Dieter Spears\r\n\r\nReleased by WMG.",
        "albumCopyright": "2026",
        "albumCopyrightDescription": "Wayfarer Records",
        "albumGenres": "Ambient, Ambient Chill, Electronic, Instrumental, Pop, Spa, Montreal",
        "albumFriendlyUrl": "Electrophonix",
        "albumSortOrder": 4,
        "albumReleaseDate": "2026-07-31T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 327,
            "fK_AlbumId": 43,
            "trackNumber": 1,
            "trackTitle": "Electrophonix",
            "trackMP3": "DinoPacifici-Electrophonix-01-Electrophonix.mp3",
            "trackLength": "00:04:27",
            "trackDescription": null
          },
          {
            "pK_TrackId": 328,
            "fK_AlbumId": 43,
            "trackNumber": 2,
            "trackTitle": "Cool Montreal Nights",
            "trackMP3": "DinoPacifici-Electrophonix-02-CoolMontrealNights.mp3",
            "trackLength": "00:06:38",
            "trackDescription": null
          },
          {
            "pK_TrackId": 329,
            "fK_AlbumId": 43,
            "trackNumber": 3,
            "trackTitle": "A Walk Through An Ancient Forest",
            "trackMP3": "DinoPacifici-Electrophonix-03-AWalkThroughAnAncientForest.mp3",
            "trackLength": "00:06:00",
            "trackDescription": null
          },
          {
            "pK_TrackId": 330,
            "fK_AlbumId": 43,
            "trackNumber": 4,
            "trackTitle": "Voices In The Void",
            "trackMP3": "DinoPacifici-Electrophonix-04-VoicesInTheVoid.mp3",
            "trackLength": "00:05:13",
            "trackDescription": null
          },
          {
            "pK_TrackId": 331,
            "fK_AlbumId": 43,
            "trackNumber": 5,
            "trackTitle": "The Crystal Gardens Of Titan",
            "trackMP3": "DinoPacifici-Electrophonix-05-TheCrystalGardensOfTitan.mp3",
            "trackLength": "00:04:23",
            "trackDescription": null
          },
          {
            "pK_TrackId": 332,
            "fK_AlbumId": 43,
            "trackNumber": 6,
            "trackTitle": "Fried Green Mechanisms",
            "trackMP3": "DinoPacifici-Electrophonix-06-FriedGreenMechanisms.mp3",
            "trackLength": "00:04:10",
            "trackDescription": null
          },
          {
            "pK_TrackId": 333,
            "fK_AlbumId": 43,
            "trackNumber": 7,
            "trackTitle": "Serata In Citta",
            "trackMP3": "DinoPacifici-Electrophonix-07-SerataInCitta.mp3",
            "trackLength": "00:04:18",
            "trackDescription": null
          },
          {
            "pK_TrackId": 334,
            "fK_AlbumId": 43,
            "trackNumber": 8,
            "trackTitle": "Poltergeist",
            "trackMP3": "DinoPacifici-Electrophonix-08-Poltergeist.mp3",
            "trackLength": "00:05:21",
            "trackDescription": null
          },
          {
            "pK_TrackId": 335,
            "fK_AlbumId": 43,
            "trackNumber": 9,
            "trackTitle": "Summer In Dystopia",
            "trackMP3": "DinoPacifici-Electrophonix-09-SummerInDystopia.mp3",
            "trackLength": "00:05:16",
            "trackDescription": null
          },
          {
            "pK_TrackId": 336,
            "fK_AlbumId": 43,
            "trackNumber": 10,
            "trackTitle": "Weekend In Magellanic Clouds",
            "trackMP3": "DinoPacifici-Electrophonix-10-WeekendInMagellanicClouds.mp3",
            "trackLength": "00:05:14",
            "trackDescription": null
          },
          {
            "pK_TrackId": 337,
            "fK_AlbumId": 43,
            "trackNumber": 11,
            "trackTitle": "Land Of The Majestic Mountains",
            "trackMP3": "DinoPacifici-Electrophonix-11-LandOfTheMajesticMountains.mp3",
            "trackLength": "00:03:27",
            "trackDescription": null
          },
          {
            "pK_TrackId": 338,
            "fK_AlbumId": 43,
            "trackNumber": 12,
            "trackTitle": "Dancing With Les Etoiles",
            "trackMP3": "DinoPacifici-Electrophonix-12-DancingWithLesEtoiles.mp3",
            "trackLength": "00:03:58",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 49,
            "fK_AlbumId": 43,
            "linkSiteName": "BandCamp - Dino Pacifici",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/electrophonix",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          },
          {
            "pK_BuyAtId": 50,
            "fK_AlbumId": 43,
            "linkSiteName": "BandCamp - Wayfarer",
            "linkUrl": "https://wayfarermusicgroup.bandcamp.com/album/electrophonix",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 2,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 45,
        "fK_ArtistId": 1,
        "albumTitle": "Soft Winds",
        "albumImageCover": "Dino_Pacifici_Soft_Winds.jpg",
        "albumImageBack": null,
        "albumLength": "00:38:00",
        "albumStory": "Soft Winds is a phrase used to lovingly express \"May the wind be at your back” rather than a goodbye for a short time or forever.\r\nThe album Soft Winds was inspired by positive relationships and musically describes the beauty of human relationships in all its forms.",
        "albumInformation": "Producers: Theresa Bentley, Dino Pacifici, Mark Bentley\r\n\r\nRecording: Bentley Recording Studios, Scorpio Rising Music\r\n\r\nMixing and Mastering: Scorpio Rising Music\r\n\r\nPress contact: theresa.Bentley@aol.com\r\n\r\nWebsite: www.thebentleyprojectmusic.com\r\n\r\nWebsite: dinopacificimusic.com\r\n\r\nCover art: Photography - Theresa Bentley\r\n\r\nArt - Rhoda Powers, Oil and glass\r\n\r\nTheresa Bentley: Harp, Synth, Voice, Piano,Spoken Word, Composer\r\n\r\nDino Pacifici: Electric Guitar, Synth, Fretless Bass, Composer\r\n\r\nMark Bentley: Classical Guitar, Acoustic Guitar\r\n\r\nJJRD: Synth\r\n\r\nDana Woolard: Cello\r\n\r\nGwendolyn Bell: Oboe\r\n\r\nPaige McCalley: Voice\r\n\r\nMiss Charlie: Spoken Word\r\n",
        "albumCopyright": "2026",
        "albumCopyrightDescription": "",
        "albumGenres": null,
        "albumFriendlyUrl": "Soft-Winds",
        "albumSortOrder": 3,
        "albumReleaseDate": "2026-06-12T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 348,
            "fK_AlbumId": 45,
            "trackNumber": 1,
            "trackTitle": "Embrace The Mist",
            "trackMP3": "DinoPacifici-SoftWinds-01-EmbraceTheMist.mp3",
            "trackLength": "00:04:03",
            "trackDescription": null
          },
          {
            "pK_TrackId": 349,
            "fK_AlbumId": 45,
            "trackNumber": 2,
            "trackTitle": "Shared Breath",
            "trackMP3": "DinoPacifici-SoftWinds-02-SharedBreath.mp3",
            "trackLength": "00:04:29",
            "trackDescription": null
          },
          {
            "pK_TrackId": 350,
            "fK_AlbumId": 45,
            "trackNumber": 3,
            "trackTitle": "Sign In The Night",
            "trackMP3": "DinoPacifici-SoftWinds-03-SighInTheNight.mp3",
            "trackLength": "00\"03:16",
            "trackDescription": null
          },
          {
            "pK_TrackId": 351,
            "fK_AlbumId": 45,
            "trackNumber": 4,
            "trackTitle": "Tranquil Eyes",
            "trackMP3": "DinoPacifici-SoftWinds-04-TranquilEyes.mp3",
            "trackLength": "00:05:09",
            "trackDescription": null
          },
          {
            "pK_TrackId": 352,
            "fK_AlbumId": 45,
            "trackNumber": 5,
            "trackTitle": "The Ancestral Chain.mp3",
            "trackMP3": "DinoPacifici-SoftWinds-05-TheAncestralChain.mp3",
            "trackLength": "00:03:09",
            "trackDescription": null
          },
          {
            "pK_TrackId": 353,
            "fK_AlbumId": 45,
            "trackNumber": 6,
            "trackTitle": "Soft Winds",
            "trackMP3": "DinoPacifici-SoftWinds-06-SoftWinds.mp3",
            "trackLength": "00:04:06",
            "trackDescription": null
          },
          {
            "pK_TrackId": 354,
            "fK_AlbumId": 45,
            "trackNumber": 7,
            "trackTitle": "Glimmers (Instrumental)",
            "trackMP3": "DinoPacifici-SoftWinds-07-Glimmers(Instrumental).mp3",
            "trackLength": "00:04:32",
            "trackDescription": null
          },
          {
            "pK_TrackId": 355,
            "fK_AlbumId": 45,
            "trackNumber": 8,
            "trackTitle": "Poetic Solitude",
            "trackMP3": "DinoPacifici-SoftWinds-08-PoeticSolitude.mp3",
            "trackLength": "00:04:43",
            "trackDescription": null
          },
          {
            "pK_TrackId": 356,
            "fK_AlbumId": 45,
            "trackNumber": 9,
            "trackTitle": "Glimmers (Spoken Words)",
            "trackMP3": "DinoPacifici-SoftWinds-09-Glimmers(SpokenWord).mp3",
            "trackLength": "00:04:31",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 53,
            "fK_AlbumId": 45,
            "linkSiteName": "BandCamp - Dino Pacifici",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/soft-winds",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          },
          {
            "pK_BuyAtId": 54,
            "fK_AlbumId": 45,
            "linkSiteName": "BandCamp - Theresa",
            "linkUrl": "https://thebentleyproject.bandcamp.com/album/soft-winds",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 42,
        "fK_ArtistId": 1,
        "albumTitle": "Future Noir",
        "albumImageCover": "Dino_Pacifici_Future_Noir.jpg",
        "albumImageBack": null,
        "albumLength": "00:56:04",
        "albumStory": "A mix of different electronic, chill styles refecting my moods in these trying times....",
        "albumInformation": null,
        "albumCopyright": "2026",
        "albumCopyrightDescription": "Wayfarer Records",
        "albumGenres": "Ambient, Ambient Chill, Electronic, Instrumental, Pop, Spa, Montreal",
        "albumFriendlyUrl": "Future-Noir",
        "albumSortOrder": 2,
        "albumReleaseDate": "2026-03-27T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 317,
            "fK_AlbumId": 42,
            "trackNumber": 1,
            "trackTitle": "Future Noir",
            "trackMP3": "DinoPacifici-FutureNoir-01-FutureNoir.mp3",
            "trackLength": "00:05:21",
            "trackDescription": null
          },
          {
            "pK_TrackId": 318,
            "fK_AlbumId": 42,
            "trackNumber": 2,
            "trackTitle": "Ecce Omnia (With Keith Fiala)",
            "trackMP3": "DinoPacifici-FutureNoir-02-EcceOmniaWithKeithFiala.mp3",
            "trackLength": "00:06:03",
            "trackDescription": null
          },
          {
            "pK_TrackId": 319,
            "fK_AlbumId": 42,
            "trackNumber": 3,
            "trackTitle": "The Alchemist's Cauldron",
            "trackMP3": "DinoPacifici-FutureNoir-03-TheAlchemistsCauldron.mp3",
            "trackLength": "00:05:51",
            "trackDescription": null
          },
          {
            "pK_TrackId": 320,
            "fK_AlbumId": 42,
            "trackNumber": 4,
            "trackTitle": "Illumite (With mRn)",
            "trackMP3": "DinoPacifici-FutureNoir-04-IllumiteWithmRn.mp3",
            "trackLength": "00:06:15",
            "trackDescription": null
          },
          {
            "pK_TrackId": 321,
            "fK_AlbumId": 42,
            "trackNumber": 5,
            "trackTitle": "The Fall Of Hades",
            "trackMP3": "DinoPacifici-FutureNoir-05-TheFallOfHades.mp3",
            "trackLength": "00:04:17",
            "trackDescription": null
          },
          {
            "pK_TrackId": 322,
            "fK_AlbumId": 42,
            "trackNumber": 6,
            "trackTitle": "Mid-Town Vibe",
            "trackMP3": "DinoPacifici-FutureNoir-06-MidTownVibe.mp3",
            "trackLength": "00:05:49",
            "trackDescription": null
          },
          {
            "pK_TrackId": 323,
            "fK_AlbumId": 42,
            "trackNumber": 7,
            "trackTitle": "The Edge Of Awareness",
            "trackMP3": "DinoPacifici-FutureNoir-07-TheEdgeOfAwareness.mp3",
            "trackLength": "00:06:10",
            "trackDescription": null
          },
          {
            "pK_TrackId": 324,
            "fK_AlbumId": 42,
            "trackNumber": 8,
            "trackTitle": "The Infinite Path",
            "trackMP3": "DinoPacifici-FutureNoir-08-TheInfinitePath.mp3",
            "trackLength": "00:05:50",
            "trackDescription": null
          },
          {
            "pK_TrackId": 325,
            "fK_AlbumId": 42,
            "trackNumber": 9,
            "trackTitle": "Echo Mountain",
            "trackMP3": "DinoPacifici-FutureNoir-09-EchoMountain.mp3",
            "trackLength": "00:04:05",
            "trackDescription": null
          },
          {
            "pK_TrackId": 326,
            "fK_AlbumId": 42,
            "trackNumber": 10,
            "trackTitle": "Plentitude In Solitude",
            "trackMP3": "DinoPacifici-FutureNoir-10-PlentitudeInSolitude.mp3",
            "trackLength": "00:06:18",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 47,
            "fK_AlbumId": 42,
            "linkSiteName": "BandCamp - Dino Pacifici",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/future-noir",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          },
          {
            "pK_BuyAtId": 48,
            "fK_AlbumId": 42,
            "linkSiteName": "BandCamp - Wayfarer",
            "linkUrl": "https://wayfarermusicgroup.bandcamp.com/album/future-noir",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 2,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 41,
        "fK_ArtistId": 1,
        "albumTitle": "Imaginary Horizons 2",
        "albumImageCover": "Dino_Pacifici_Brannan_Lane_Imaginary_Horizons_2.jpg",
        "albumImageBack": null,
        "albumLength": "00:52:48",
        "albumStory": "Sonic Cartography: Mapping the Hidden Depths\r\nand Cosmic Heights of Imaginary Horizons 2\r\n\r\nListening to Imaginary Horizons 2 feels like rediscovering a rare \"Headphone Masterpiece\" from the back bin of a 1970s record shop—the kind of album that promises a journey and actually delivers one. Dino Pacifici and Brannan Lane have moved beyond mere atmosphere, crafting a 12-track narrative that feels as much like a speculative sci-fi broadcast as it does a modern ambient suite. While the duo is credited as co-composers, the album thrives on a distinct division of labor that honors their individual strengths. Lane, acting as the atmospheric architect, provides the rhythmic \"foundation tracks\"—the pulsing heartbeats and sequencers that keep the journey on course—while Pacifici layers a sophisticated array of analog and digital synthesis, acting as the lead sound designer and mixing engineer. Together with mastering by Dionisaf and striking cover art by Wayfarer Owner/President Dieter Spears, they have created a work that is both technically pristine and emotionally resonant.\r\n\r\nThe experience is a palpable migration that begins in the shimmering heights of \"Glow Of The Seven Sisters.\" Here, Pacifici utilizes high-frequency \"shimmers\"—synths that possess the...  more",
        "albumInformation": "Composed, recorded and arranged by: Dino Pacifici and Brannan Lane.\r\n\r\nMixed by: Dino Pacifici\r\n\r\nBrannan Lane: Foundation tracks, percs, synths.\r\n\r\nDino Pacifici : Analog and digital synths, percs, sound design.\r\n\r\nCover: Dieter Spears.\r\n\r\nMastered: Dionisaf",
        "albumCopyright": "2026",
        "albumCopyrightDescription": "Wayfarer Records",
        "albumGenres": "Ambient, Chill, Electronic, Pop, Spa, Montreal",
        "albumFriendlyUrl": "Imaginary-Horizons-2",
        "albumSortOrder": 1,
        "albumReleaseDate": "2026-02-27T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 305,
            "fK_AlbumId": 41,
            "trackNumber": 1,
            "trackTitle": "Glow Of The Seven Sisters",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons2-01-GlowOfTheSevenSisters.mp3",
            "trackLength": "00:05:25",
            "trackDescription": null
          },
          {
            "pK_TrackId": 306,
            "fK_AlbumId": 41,
            "trackNumber": 2,
            "trackTitle": "Seabed",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons2-02-Seabed.mp3",
            "trackLength": "00:03:13",
            "trackDescription": null
          },
          {
            "pK_TrackId": 307,
            "fK_AlbumId": 41,
            "trackNumber": 3,
            "trackTitle": "Underwater",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons2-03-Underwater.mp3",
            "trackLength": "00:03:31",
            "trackDescription": null
          },
          {
            "pK_TrackId": 308,
            "fK_AlbumId": 41,
            "trackNumber": 4,
            "trackTitle": "Primordial Pools",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons2-04-PrimordialPools.mp3",
            "trackLength": "00:04:24",
            "trackDescription": null
          },
          {
            "pK_TrackId": 309,
            "fK_AlbumId": 41,
            "trackNumber": 5,
            "trackTitle": "Flotation Device",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons2-05-FlotationDevice.mp3",
            "trackLength": "00:04:07",
            "trackDescription": null
          },
          {
            "pK_TrackId": 310,
            "fK_AlbumId": 41,
            "trackNumber": 6,
            "trackTitle": "Cold Fusion",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons2-06-ColdFusion.mp3",
            "trackLength": "00:03:29",
            "trackDescription": null
          },
          {
            "pK_TrackId": 311,
            "fK_AlbumId": 41,
            "trackNumber": 7,
            "trackTitle": "Boiling Point",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons2-07-BoilingPoint.mp3",
            "trackLength": "00:03:17",
            "trackDescription": null
          },
          {
            "pK_TrackId": 312,
            "fK_AlbumId": 41,
            "trackNumber": 8,
            "trackTitle": "Background Radiation",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons2-08-BackgroundRadiation.mp3",
            "trackLength": "00:04:46",
            "trackDescription": null
          },
          {
            "pK_TrackId": 313,
            "fK_AlbumId": 41,
            "trackNumber": 9,
            "trackTitle": "Space Station Sanctuary",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons2-09-SpaceStationSanctuary.mp3",
            "trackLength": "00:04:17",
            "trackDescription": null
          },
          {
            "pK_TrackId": 314,
            "fK_AlbumId": 41,
            "trackNumber": 10,
            "trackTitle": "Space Song",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons2-10-SpaceSong.mp3",
            "trackLength": "00:04:07",
            "trackDescription": null
          },
          {
            "pK_TrackId": 315,
            "fK_AlbumId": 41,
            "trackNumber": 11,
            "trackTitle": "Undetectable Energy",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons2-11-UndetectableEnergy.mp3",
            "trackLength": "00:04:29",
            "trackDescription": null
          },
          {
            "pK_TrackId": 316,
            "fK_AlbumId": 41,
            "trackNumber": 12,
            "trackTitle": "Zodiacal Light",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons2-12-ZodiacalLight.mp3",
            "trackLength": "00:04:21",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 45,
            "fK_AlbumId": 41,
            "linkSiteName": "BandCamp - Dino Pacifici",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/imaginary-horizons-2-dino-pacifici-brannan-lane",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          },
          {
            "pK_BuyAtId": 46,
            "fK_AlbumId": 41,
            "linkSiteName": "BandCamp - Wayfarer",
            "linkUrl": "https://wayfarermusicgroup.bandcamp.com/album/imaginary-horizons-2",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 2,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 40,
        "fK_ArtistId": 1,
        "albumTitle": "Oh XMas Tree (Single)",
        "albumImageCover": "Dino_Pacifici_Oh_XMas_Tree.jpg",
        "albumImageBack": null,
        "albumLength": "00:04:51",
        "albumStory": "On the 12th Day of Wayfarers the Wayfarers gave to me ... a BONUS TRACK",
        "albumInformation": "Music produced, composed and performed by Dino Pacifici",
        "albumCopyright": "2025",
        "albumCopyrightDescription": "Wayfarer Records",
        "albumGenres": "Holiday, New Age",
        "albumFriendlyUrl": "Oh-XMas-Tree",
        "albumSortOrder": 9,
        "albumReleaseDate": "2025-12-08T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 304,
            "fK_AlbumId": 40,
            "trackNumber": 1,
            "trackTitle": "Oh XMas Tree",
            "trackMP3": "DinoPacifici-OhXMasTree-01-OhXMasTree.mp3",
            "trackLength": "00:04:51",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 44,
            "fK_AlbumId": 40,
            "linkSiteName": "BandCamp - Wayfarer",
            "linkUrl": "https://wayfarermusicgroup.bandcamp.com/track/oh-xmas-tree",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 39,
        "fK_ArtistId": 1,
        "albumTitle": "God Rest Ye Merry Gentlemen (Single)",
        "albumImageCover": "Dino_Pacifici_God_Rest_Ye.jpg",
        "albumImageBack": null,
        "albumLength": "00:05:31",
        "albumStory": "The 1st Day of the 12 Day of Wayfarers",
        "albumInformation": "Music produced, composed and performed by Dino Pacifici",
        "albumCopyright": "2025",
        "albumCopyrightDescription": "Wayfarer Records",
        "albumGenres": "Holiday, New Age",
        "albumFriendlyUrl": "God-Rest-Ye",
        "albumSortOrder": 8,
        "albumReleaseDate": "2025-11-28T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 303,
            "fK_AlbumId": 39,
            "trackNumber": 1,
            "trackTitle": "God Rest Ye Merry Gentlemen",
            "trackMP3": "DinoPacifici-GodRestYeMerryGentlemen-01-GodRestYeMerryGentlemen.mp3",
            "trackLength": "00:05:31",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 43,
            "fK_AlbumId": 39,
            "linkSiteName": "BandCamp - Wayfarer",
            "linkUrl": "https://wayfarermusicgroup.bandcamp.com/track/god-rest-ye-merry-gentlemen",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 38,
        "fK_ArtistId": 1,
        "albumTitle": "The Approaching Tempest And Other Related Tales",
        "albumImageCover": "Dino_Pacifici_The_Approaching_Tempest_And_Other_Related_Tales.jpg",
        "albumImageBack": null,
        "albumLength": "00:56:16",
        "albumStory": null,
        "albumInformation": "Critically acclaimed and highly prolific composer Dino Pacifici is back with his latest Wayfarer Records full-length release entitled The Approaching Tempest and Other Unrelated Tales. The album is a trademark Pacifici mix of eclectic styles couple with virtuosic playing.\r\n\r\nMusic Produced, Composed and Performed by Dino Pacifici ©2025\r\n\r\nMixed and Mastered by Dino Pacifici\r\n\r\nGuest appearance by Sean O'Bryan Smith on fretless bass courtesy of Wayfarer Music Group",
        "albumCopyright": "2025",
        "albumCopyrightDescription": "Wayfarer Records",
        "albumGenres": "Ambient, Chill, Electronic, Instrumental, Pop, Spa, Montreal",
        "albumFriendlyUrl": "The-Approaching-Tempest",
        "albumSortOrder": 7,
        "albumReleaseDate": "2025-09-19T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 292,
            "fK_AlbumId": 38,
            "trackNumber": 1,
            "trackTitle": "Undulations",
            "trackMP3": "DinoPacifici-TheApproachingTempestAndOtherRelatedTales-01-Undulations.mp3",
            "trackLength": "00:04:42",
            "trackDescription": null
          },
          {
            "pK_TrackId": 293,
            "fK_AlbumId": 38,
            "trackNumber": 2,
            "trackTitle": "The Spy With The X-Ray Eye",
            "trackMP3": "DinoPacifici-TheApproachingTempestAndOtherRelatedTales-02-TheSpyWithTheX-RayEye.mp3",
            "trackLength": "00:04:42",
            "trackDescription": null
          },
          {
            "pK_TrackId": 294,
            "fK_AlbumId": 38,
            "trackNumber": 3,
            "trackTitle": "Would You Like A Cup Of Tea?",
            "trackMP3": "DinoPacifici-TheApproachingTempestAndOtherRelatedTales-03-WouldYouLikeACupOfTea.mp3",
            "trackLength": "00:04:27",
            "trackDescription": null
          },
          {
            "pK_TrackId": 295,
            "fK_AlbumId": 38,
            "trackNumber": 4,
            "trackTitle": "Valley Of The Crying Winds",
            "trackMP3": "DinoPacifici-TheApproachingTempestAndOtherRelatedTales-04-ValleyOfTheCryingWinds.mp3",
            "trackLength": "00:04:32",
            "trackDescription": null
          },
          {
            "pK_TrackId": 296,
            "fK_AlbumId": 38,
            "trackNumber": 5,
            "trackTitle": "Silent Screams In Space",
            "trackMP3": "DinoPacifici-TheApproachingTempestAndOtherRelatedTales-05-SilentScreamsInSpace.mp3",
            "trackLength": "00:04:34",
            "trackDescription": null
          },
          {
            "pK_TrackId": 297,
            "fK_AlbumId": 38,
            "trackNumber": 6,
            "trackTitle": "The Unfathomable Proposal Of Time Dilation",
            "trackMP3": "DinoPacifici-TheApproachingTempestAndOtherRelatedTales-06-TheUnfathomableProposalOfTimeDilation.mp3",
            "trackLength": "00:04:09",
            "trackDescription": null
          },
          {
            "pK_TrackId": 298,
            "fK_AlbumId": 38,
            "trackNumber": 7,
            "trackTitle": "The Approaching Tempest",
            "trackMP3": "DinoPacifici-TheApproachingTempestAndOtherRelatedTales-07-TheApproachingTempest.mp3",
            "trackLength": "00:04:36",
            "trackDescription": null
          },
          {
            "pK_TrackId": 299,
            "fK_AlbumId": 38,
            "trackNumber": 8,
            "trackTitle": "The Zen Of Water Droplets",
            "trackMP3": "DinoPacifici-TheApproachingTempestAndOtherRelatedTales-08-TheZenOfWaterDroplets.mp3",
            "trackLength": "00:05:07",
            "trackDescription": null
          },
          {
            "pK_TrackId": 300,
            "fK_AlbumId": 38,
            "trackNumber": 9,
            "trackTitle": "Cloud's Drift",
            "trackMP3": "DinoPacifici-TheApproachingTempestAndOtherRelatedTales-09-CloudsDrift.mp3",
            "trackLength": "00:07:33",
            "trackDescription": null
          },
          {
            "pK_TrackId": 301,
            "fK_AlbumId": 38,
            "trackNumber": 10,
            "trackTitle": "Glitch In The Matrix",
            "trackMP3": "DinoPacifici-TheApproachingTempestAndOtherRelatedTales-10-GlitchInTheMatrix.mp3",
            "trackLength": "00:05:53",
            "trackDescription": null
          },
          {
            "pK_TrackId": 302,
            "fK_AlbumId": 38,
            "trackNumber": 11,
            "trackTitle": "Ectoplasmic Interference",
            "trackMP3": "DinoPacifici-TheApproachingTempestAndOtherRelatedTales-11-EctoplasmicInterference.mp3",
            "trackLength": "00:05:56",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 41,
            "fK_AlbumId": 38,
            "linkSiteName": "BandCamp - Dino Pacifici",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/the-approaching-tempest-and-other-related-tales",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          },
          {
            "pK_BuyAtId": 42,
            "fK_AlbumId": 38,
            "linkSiteName": "BandCamp - Wayfarer",
            "linkUrl": "https://wayfarermusicgroup.bandcamp.com/album/the-approaching-tempest-and-other-unrelated-tales",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 2,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 37,
        "fK_ArtistId": 1,
        "albumTitle": "Hello Flow (2 Song EP)",
        "albumImageCover": "Dino_Pacifici_Hello_Flow.jpg",
        "albumImageBack": null,
        "albumLength": "00:08:27",
        "albumStory": null,
        "albumInformation": "Composed, produced, performed and recorded by Dino Pacifici",
        "albumCopyright": "2025",
        "albumCopyrightDescription": "Wayfarer Records",
        "albumGenres": "Ambient, Chill, Electronic, Pop, Spa, Montreal",
        "albumFriendlyUrl": "Hello-Flow",
        "albumSortOrder": 6,
        "albumReleaseDate": "2025-08-15T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 290,
            "fK_AlbumId": 37,
            "trackNumber": 1,
            "trackTitle": "Hello Flow",
            "trackMP3": "DinoPacifici-HelloFlow-01-HelloFlow.mp3",
            "trackLength": "00:03:54",
            "trackDescription": null
          },
          {
            "pK_TrackId": 291,
            "fK_AlbumId": 37,
            "trackNumber": 2,
            "trackTitle": "It's A Little Bit...",
            "trackMP3": "DinoPacifici-HelloFlow-02-ItsALittleBit.mp3",
            "trackLength": "00:04:33",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 39,
            "fK_AlbumId": 37,
            "linkSiteName": "BandCamp - Dino Pacifici",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/hello-flow-2-song-ep",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          },
          {
            "pK_BuyAtId": 40,
            "fK_AlbumId": 37,
            "linkSiteName": "BandCamp - Wayfarer",
            "linkUrl": "https://wayfarermusicgroup.bandcamp.com/album/hello-flow",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 2,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 36,
        "fK_ArtistId": 1,
        "albumTitle": "Twiling Time (4 Song EP)",
        "albumImageCover": "Dino_Pacifici_Twilight_Time.jpg",
        "albumImageBack": null,
        "albumLength": "00:16:01",
        "albumStory": "Once in a while, I will go back to my roots, that is, the\r\ninfluences of the 70’s and 80’s and compose music with\r\nlyrics. I quite enjoy writing lyrics when I get in the\r\n“bard” mood. These tracks were composed between 2016\r\nand 2020 from different sources. Yes, it is me performing\r\nthe vocals and no, I don’t consider myself a vocalist.\r\nBut….I do enjoy trying. Hope you enjoy something a little\r\ndifferent from me. :)\r\ncredits",
        "albumInformation": "Music Composed and Performed by Dino Pacifici.\r\n\r\nAll instrumentation and vocals by Dino Pacifici\r\n\r\nMixed and mastered by Dino Pacifici at Scorpio Rising Music, Canada\r\n\r\nCover art by Dieter Spears\r\n\r\nA Groovetron Records release\r\n\r\nGroovetron Records is a proud part of the Wayfarer Music Group family of brands.\r\nlicense\r\nall rights reserved",
        "albumCopyright": "2025",
        "albumCopyrightDescription": "Wayfarer Records",
        "albumGenres": "Ambient, Dance, Modern, Pop, Vocal, Calm, Chill, Electronic, Groove, Spa",
        "albumFriendlyUrl": "Twilight-Time",
        "albumSortOrder": 5,
        "albumReleaseDate": "2025-06-16T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 286,
            "fK_AlbumId": 36,
            "trackNumber": 1,
            "trackTitle": "Stop",
            "trackMP3": "DinoPacifici-TwilightTime-01-Stop.mp3",
            "trackLength": "00:03:40",
            "trackDescription": null
          },
          {
            "pK_TrackId": 287,
            "fK_AlbumId": 36,
            "trackNumber": 2,
            "trackTitle": "It's The Summertime",
            "trackMP3": "DinoPacifici-TwilightTime-02-ItsTheSummertime.mp3",
            "trackLength": "00:04:27",
            "trackDescription": null
          },
          {
            "pK_TrackId": 288,
            "fK_AlbumId": 36,
            "trackNumber": 3,
            "trackTitle": "Twilight Time",
            "trackMP3": "DinoPacifici-TwilightTime-03-TwilightTime.mp3",
            "trackLength": "00:03:43",
            "trackDescription": null
          },
          {
            "pK_TrackId": 289,
            "fK_AlbumId": 36,
            "trackNumber": 4,
            "trackTitle": "Layers Of Confusion",
            "trackMP3": "DinoPacifici-TwilightTime-04-LayersOfConfusion.mp3",
            "trackLength": "00:04:10",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 37,
            "fK_AlbumId": 36,
            "linkSiteName": "BandCamp - Dino Pacifici",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/twilight-time-4-song-ep",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          },
          {
            "pK_BuyAtId": 38,
            "fK_AlbumId": 36,
            "linkSiteName": "BandCamp - Wayfarer",
            "linkUrl": "https://wayfarermusicgroup.bandcamp.com/album/twilight-time",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 2,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 35,
        "fK_ArtistId": 1,
        "albumTitle": "Unfocused Dream Fragments",
        "albumImageCover": "Dino_Pacifici_Unfocused_Dream_Fragments.jpg",
        "albumImageBack": null,
        "albumLength": "00:58:28",
        "albumStory": null,
        "albumInformation": "Instruments used in this recording: Moog Matriarch, Prophet 10, K2000, Kontakt, Steinberger guitars, Fender guitars, Vox amp, various pedals in Logic Pro.\r\n\r\nThis album is mix of totally different styles and genres showing diversity and constant change. It's a roller coaster of moods.\r\n\r\nCredits: Composed, performed, recorded and mixed by Dino Pacifici for Scorpio Rising Music partnered with Wayfarer Records.\r\n\r\nMastered by: Dionisaf\r\n\r\nOrder Sequencing by Richard J. Krainak\r\n\r\nCover art by Dieter Spears",
        "albumCopyright": "2025",
        "albumCopyrightDescription": "Wayfarer Records",
        "albumGenres": "Ambient, Calm, Chill, Electronic, Smooth Jazz, Spa",
        "albumFriendlyUrl": "Unfocused-Dream-Fragments",
        "albumSortOrder": 4,
        "albumReleaseDate": "2025-06-07T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 274,
            "fK_AlbumId": 35,
            "trackNumber": 1,
            "trackTitle": "Borne On The West Wind",
            "trackMP3": "DinoPacifici-UnfocusedDreamFragments-01-BorneOnTheWestWind.mp3",
            "trackLength": "00:04:20",
            "trackDescription": null
          },
          {
            "pK_TrackId": 275,
            "fK_AlbumId": 35,
            "trackNumber": 2,
            "trackTitle": "Valency",
            "trackMP3": "DinoPacifici-UnfocusedDreamFragments-02-Valency.mp3",
            "trackLength": "00:04:19",
            "trackDescription": null
          },
          {
            "pK_TrackId": 276,
            "fK_AlbumId": 35,
            "trackNumber": 3,
            "trackTitle": "The Runner",
            "trackMP3": "DinoPacifici-UnfocusedDreamFragments-03-TheRunner.mp3",
            "trackLength": "00:04:35",
            "trackDescription": null
          },
          {
            "pK_TrackId": 277,
            "fK_AlbumId": 35,
            "trackNumber": 4,
            "trackTitle": "El Camino Al Nirvana (With Sean O'Bryan Smith)",
            "trackMP3": "DinoPacifici-UnfocusedDreamFragments-04-ElCaminoAlNirvanaWithSeanOBryanSmith.mp3",
            "trackLength": "00:05:03",
            "trackDescription": null
          },
          {
            "pK_TrackId": 278,
            "fK_AlbumId": 35,
            "trackNumber": 5,
            "trackTitle": "Birds Of Aldebaron",
            "trackMP3": "DinoPacifici-UnfocusedDreamFragments-05-BirdsOfAldebaron.mp3",
            "trackLength": "00:04:41",
            "trackDescription": null
          },
          {
            "pK_TrackId": 279,
            "fK_AlbumId": 35,
            "trackNumber": 6,
            "trackTitle": "Surf Along The Shore",
            "trackMP3": "DinoPacifici-UnfocusedDreamFragments-06-SurfAlongTheShore.mp3",
            "trackLength": "00:06:29",
            "trackDescription": null
          },
          {
            "pK_TrackId": 280,
            "fK_AlbumId": 35,
            "trackNumber": 7,
            "trackTitle": "The Quirky Pastiche",
            "trackMP3": "DinoPacifici-UnfocusedDreamFragments-07-TheQuirkyPastiche.mp3",
            "trackLength": "00:08:21",
            "trackDescription": null
          },
          {
            "pK_TrackId": 281,
            "fK_AlbumId": 35,
            "trackNumber": 8,
            "trackTitle": "Dance Of The Damselfish",
            "trackMP3": "DinoPacifici-UnfocusedDreamFragments-08-DanceOfTheDamselfish.mp3",
            "trackLength": "00:04:17",
            "trackDescription": null
          },
          {
            "pK_TrackId": 282,
            "fK_AlbumId": 35,
            "trackNumber": 9,
            "trackTitle": "Eastern Winds",
            "trackMP3": "DinoPacifici-UnfocusedDreamFragments-09-EasternWinds.mp3",
            "trackLength": "00:04:41",
            "trackDescription": null
          },
          {
            "pK_TrackId": 283,
            "fK_AlbumId": 35,
            "trackNumber": 10,
            "trackTitle": "Serene Scene",
            "trackMP3": "DinoPacifici-UnfocusedDreamFragments-10-SereneScene.mp3",
            "trackLength": "00:03:16",
            "trackDescription": null
          },
          {
            "pK_TrackId": 284,
            "fK_AlbumId": 35,
            "trackNumber": 11,
            "trackTitle": "Random Static Elements",
            "trackMP3": "DinoPacifici-UnfocusedDreamFragments-11-RandomStaticActs.mp3",
            "trackLength": "00:04:46",
            "trackDescription": null
          },
          {
            "pK_TrackId": 285,
            "fK_AlbumId": 35,
            "trackNumber": 12,
            "trackTitle": "Vision Of Ascension",
            "trackMP3": "DinoPacifici-UnfocusedDreamFragments-12-VisionOfAscension.mp3",
            "trackLength": "00:03:37",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 35,
            "fK_AlbumId": 35,
            "linkSiteName": "BandCamp - Dino Pacifici",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/unfocused-dream-fragments",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          },
          {
            "pK_BuyAtId": 36,
            "fK_AlbumId": 35,
            "linkSiteName": "BandCamp - Wayfarer",
            "linkUrl": "https://wayfarermusicgroup.bandcamp.com/album/unfocused-dream-fragments",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 2,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 34,
        "fK_ArtistId": 1,
        "albumTitle": "Imaginary Horizons",
        "albumImageCover": "Dino_Pacifici_Brannan_Lane_Imaginary_Horizons.jpg",
        "albumImageBack": null,
        "albumLength": "00:46:00",
        "albumStory": "Released February 28, 2025\r\n\r\nComposed, produced, performed and arranged by: Brannan Lane and Dino Pacifici.\r\n\r\nDino Pacifici: Moog Matriarch, Prophet 10, Korg Minilogue XD, Native Instruments Kontakt, Kurzweil K2000, assorted udu and exotic percs , Apollo 8 Quad with Logic Pro 11. 2.\r\n\r\nBrannan Lane: Yamaha Keyboards,  Pearl Drums, Field Recording and Vocal Effects.\r\n\r\nMastered by Dionisaf\r\n\r\nWayfarer Records - 2025\r\n\r\nA Wayfarer Records release",
        "albumInformation": "",
        "albumCopyright": "2025",
        "albumCopyrightDescription": "Wayfarer Records",
        "albumGenres": "Ambient, Chill, Electronic, Pop, Spa, Montreal",
        "albumFriendlyUrl": "Imaginary-Horizons",
        "albumSortOrder": 3,
        "albumReleaseDate": "2025-02-26T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 264,
            "fK_AlbumId": 34,
            "trackNumber": 1,
            "trackTitle": "The Whispers Of The Wind",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons-01-The WhispersOfTheWind.mp3",
            "trackLength": "00:03:45",
            "trackDescription": null
          },
          {
            "pK_TrackId": 265,
            "fK_AlbumId": 34,
            "trackNumber": 2,
            "trackTitle": "Summer Chill",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons-02-SummerChill.mp3",
            "trackLength": "00:04:33",
            "trackDescription": null
          },
          {
            "pK_TrackId": 266,
            "fK_AlbumId": 34,
            "trackNumber": 3,
            "trackTitle": "Windsong",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons-03-Windsong.mp3",
            "trackLength": "00:03:49",
            "trackDescription": null
          },
          {
            "pK_TrackId": 267,
            "fK_AlbumId": 34,
            "trackNumber": 4,
            "trackTitle": "Inevitable Entropy",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons-04-InevitableEntropy.mp3",
            "trackLength": "00:05:17",
            "trackDescription": null
          },
          {
            "pK_TrackId": 268,
            "fK_AlbumId": 34,
            "trackNumber": 5,
            "trackTitle": "Evening Breeze",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons-05-EveningBreeze.mp3",
            "trackLength": "00:04:40",
            "trackDescription": null
          },
          {
            "pK_TrackId": 269,
            "fK_AlbumId": 34,
            "trackNumber": 6,
            "trackTitle": "Amazon Mist",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons-06-AmazonMist.mp3",
            "trackLength": "00:05:05",
            "trackDescription": null
          },
          {
            "pK_TrackId": 270,
            "fK_AlbumId": 34,
            "trackNumber": 7,
            "trackTitle": "The Serenity Of Dreams",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons-07-The SerenityOfDreams.mp3",
            "trackLength": "00:04:30",
            "trackDescription": null
          },
          {
            "pK_TrackId": 271,
            "fK_AlbumId": 34,
            "trackNumber": 8,
            "trackTitle": "Cave Of The Crystal",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons-08-CaveOfTheCrystal.mp3",
            "trackLength": "00:03:51",
            "trackDescription": null
          },
          {
            "pK_TrackId": 272,
            "fK_AlbumId": 34,
            "trackNumber": 9,
            "trackTitle": "Heart Of The Machine",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons-09-HeartOfTheMachine.mp3",
            "trackLength": "00:04:41",
            "trackDescription": null
          },
          {
            "pK_TrackId": 273,
            "fK_AlbumId": 34,
            "trackNumber": 10,
            "trackTitle": "Cruise",
            "trackMP3": "DinoPacifici-BrannanLane-ImaginaryHorizons-10-Cruise.mp3",
            "trackLength": "00:05:43",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 33,
            "fK_AlbumId": 34,
            "linkSiteName": "BandCamp - Dino Pacifici",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/imaginary-horizons",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          },
          {
            "pK_BuyAtId": 34,
            "fK_AlbumId": 34,
            "linkSiteName": "BandCamp - Wayfarer",
            "linkUrl": "https://wayfarermusicgroup.bandcamp.com/album/imaginary-horizons",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 2,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 33,
        "fK_ArtistId": 1,
        "albumTitle": "Beyond The Solar Influence",
        "albumImageCover": "Dino_Pacifici_Beyond_The_Solar_Influence_.jpg",
        "albumImageBack": null,
        "albumLength": "01:00:27",
        "albumStory": null,
        "albumInformation": "Composed, produced, performed and recorded by Dino Pacifici.",
        "albumCopyright": "2025",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "Beyond-The-Solar-Influence",
        "albumSortOrder": 2,
        "albumReleaseDate": "2025-01-14T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 257,
            "fK_AlbumId": 33,
            "trackNumber": 1,
            "trackTitle": "The Quiet Sun",
            "trackMP3": "DinoPacifici-BeyondTheSolarInfluence-01-TheQuietSun.mp3",
            "trackLength": "00:11:40",
            "trackDescription": null
          },
          {
            "pK_TrackId": 258,
            "fK_AlbumId": 33,
            "trackNumber": 2,
            "trackTitle": "Sol Dancing With Luna",
            "trackMP3": "DinoPacifici-BeyondTheSolarInfluence-02-SolDancingWithLuna.mp3",
            "trackLength": "00:05:36",
            "trackDescription": null
          },
          {
            "pK_TrackId": 259,
            "fK_AlbumId": 33,
            "trackNumber": 3,
            "trackTitle": "The Solar System's Sweet Ballet",
            "trackMP3": "DinoPacifici-BeyondTheSolarInfluence-03-TheSolarSystemsSweetBallet.mp3",
            "trackLength": "00:06:12",
            "trackDescription": null
          },
          {
            "pK_TrackId": 260,
            "fK_AlbumId": 33,
            "trackNumber": 4,
            "trackTitle": "Indonesian Sun",
            "trackMP3": "DinoPacifici-BeyondTheSolarInfluence-04-IndonesianSun.mp3",
            "trackLength": "00:07:28",
            "trackDescription": null
          },
          {
            "pK_TrackId": 261,
            "fK_AlbumId": 33,
            "trackNumber": 5,
            "trackTitle": "The Solar Wind",
            "trackMP3": "DinoPacifici-BeyondTheSolarInfluence-05-TheSolarWind.mp3",
            "trackLength": "00:05:34",
            "trackDescription": null
          },
          {
            "pK_TrackId": 262,
            "fK_AlbumId": 33,
            "trackNumber": 6,
            "trackTitle": "Sol Searching",
            "trackMP3": "DinoPacifici-BeyondTheSolarInfluence-06-SolSearching.mp3",
            "trackLength": "00:11:02",
            "trackDescription": null
          },
          {
            "pK_TrackId": 263,
            "fK_AlbumId": 33,
            "trackNumber": 7,
            "trackTitle": "Beyond The Solar Influence",
            "trackMP3": "DinoPacifici-BeyondTheSolarInfluence-07-BeyondTheSolarInfluence.mp3",
            "trackLength": "00:12:52",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 32,
            "fK_AlbumId": 33,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/beyond-the-solar-influence",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 32,
        "fK_ArtistId": 1,
        "albumTitle": "Hyperdrone City",
        "albumImageCover": "Dino_Pacifici_Hyperdrone_City_Front.jpg",
        "albumImageBack": null,
        "albumLength": "00:55:23",
        "albumStory": "A 55 minute ambient track suitable for casual listening, meditation, yoga, sonic wallpaper, taking a bath, trying to sleep, whatever you like...! :)\r\n\r\nThis is a free download in celebration of the new year and my appreciation for all my friends and fans. Thank you for your continued support. :)",
        "albumInformation": "Composed, produced and performed by Dino Pacifici.",
        "albumCopyright": "2025",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "Hyperdrone-City",
        "albumSortOrder": 1,
        "albumReleaseDate": "2025-01-02T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 256,
            "fK_AlbumId": 32,
            "trackNumber": 1,
            "trackTitle": "Hyperdrone City (Long Form Single)",
            "trackMP3": "DinoPacifici-HyperdroneCity-01-HyperdroneCity.mp3",
            "trackLength": "00:55:23",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 31,
            "fK_AlbumId": 32,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/track/hyperdrone-city-long-form-single",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 31,
        "fK_ArtistId": 1,
        "albumTitle": "Musings Of A Matriarch",
        "albumImageCover": "Dino_Pacifici_Musings_Of_A_Matriarch.jpg",
        "albumImageBack": null,
        "albumLength": "01:00:47",
        "albumStory": "As it is, I have recently acquired a Moog Matriarch synth and, being a total newb, I decided the only way to learn this incredible instrument is to just dive in. All the tracks on this album are minimalist four or five track recordings improvised live in my studio with the Matriarch alone! To say this was fun is an understatement. I did not really know what I was doing but, well, I did it. Hopefully the music…noise…glitch… will bring you some listening enjoyment. It was a blast trying to get beautiful sounds out of this awesome synth. The sonic explorations continue…\r\n\r\nDee :)\r\n\r\nMay, 2024.\r\n\r\nPS: This project is a randomly, conflagratory, allegory, lavatory, Rick and Morty, inspiratory, celebratory, Jerry or Maury, explanatory, full of semi-modular glory and I am not sorry …about this story …  or, maybe, work of art.    Thank you. ;)\r\n",
        "albumInformation": "Composed, performed and recorded by Dino Pacifici",
        "albumCopyright": "2024",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "Musings-Of-A-Matriarch",
        "albumSortOrder": 4,
        "albumReleaseDate": "2024-07-12T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 242,
            "fK_AlbumId": 31,
            "trackNumber": 1,
            "trackTitle": "Project Matriarch 1",
            "trackMP3": "DinoPacifici-MusingsOfAMatriarch-01-ProjectMatriarch1.mp3",
            "trackLength": "00:03:55",
            "trackDescription": null
          },
          {
            "pK_TrackId": 243,
            "fK_AlbumId": 31,
            "trackNumber": 2,
            "trackTitle": "Project Matriarch 2",
            "trackMP3": "DinoPacifici-MusingsOfAMatriarch-02-ProjectMatriarch2.mp3",
            "trackLength": "00:04:00",
            "trackDescription": null
          },
          {
            "pK_TrackId": 244,
            "fK_AlbumId": 31,
            "trackNumber": 3,
            "trackTitle": "Project Matriarch 3",
            "trackMP3": "DinoPacifici-MusingsOfAMatriarch-03-ProjectMatriarch3.mp3",
            "trackLength": "00:04:04",
            "trackDescription": null
          },
          {
            "pK_TrackId": 245,
            "fK_AlbumId": 31,
            "trackNumber": 4,
            "trackTitle": "Project Matriarch 4",
            "trackMP3": "DinoPacifici-MusingsOfAMatriarch-04-ProjectMatriarch4.mp3",
            "trackLength": "00:04:21",
            "trackDescription": null
          },
          {
            "pK_TrackId": 246,
            "fK_AlbumId": 31,
            "trackNumber": 5,
            "trackTitle": "Project Matriarch 5",
            "trackMP3": "DinoPacifici-MusingsOfAMatriarch-05-ProjectMatriarch5.mp3",
            "trackLength": "00:04:23",
            "trackDescription": null
          },
          {
            "pK_TrackId": 247,
            "fK_AlbumId": 31,
            "trackNumber": 6,
            "trackTitle": "Project Matriarch 6",
            "trackMP3": "DinoPacifici-MusingsOfAMatriarch-06-ProjectMatriarch6.mp3",
            "trackLength": "00:05:04",
            "trackDescription": null
          },
          {
            "pK_TrackId": 248,
            "fK_AlbumId": 31,
            "trackNumber": 7,
            "trackTitle": "Project Matriarch 7",
            "trackMP3": "DinoPacifici-MusingsOfAMatriarch-07-ProjectMatriarch7.mp3",
            "trackLength": "00:04:20",
            "trackDescription": null
          },
          {
            "pK_TrackId": 249,
            "fK_AlbumId": 31,
            "trackNumber": 8,
            "trackTitle": "Project Matriarch 8",
            "trackMP3": "DinoPacifici-MusingsOfAMatriarch-08-ProjectMatriarch8.mp3",
            "trackLength": "00:04:23",
            "trackDescription": null
          },
          {
            "pK_TrackId": 250,
            "fK_AlbumId": 31,
            "trackNumber": 9,
            "trackTitle": "Project Matriarch 9",
            "trackMP3": "DinoPacifici-MusingsOfAMatriarch-09-ProjectMatriarch9.mp3",
            "trackLength": "00:04:44",
            "trackDescription": null
          },
          {
            "pK_TrackId": 251,
            "fK_AlbumId": 31,
            "trackNumber": 10,
            "trackTitle": "Project Matriarch 10",
            "trackMP3": "DinoPacifici-MusingsOfAMatriarch-10-ProjectMatriarch10.mp3",
            "trackLength": "00:04:19",
            "trackDescription": null
          },
          {
            "pK_TrackId": 252,
            "fK_AlbumId": 31,
            "trackNumber": 11,
            "trackTitle": "Project Matriarch 11",
            "trackMP3": "DinoPacifici-MusingsOfAMatriarch-11-ProjectMatriarch11.mp3",
            "trackLength": "00:03:53",
            "trackDescription": null
          },
          {
            "pK_TrackId": 253,
            "fK_AlbumId": 31,
            "trackNumber": 12,
            "trackTitle": "Project Matriarch 12",
            "trackMP3": "DinoPacifici-MusingsOfAMatriarch-12-ProjectMatriarch12.mp3",
            "trackLength": "00:04:48",
            "trackDescription": null
          },
          {
            "pK_TrackId": 254,
            "fK_AlbumId": 31,
            "trackNumber": 13,
            "trackTitle": "Project Matriarch 13",
            "trackMP3": "DinoPacifici-MusingsOfAMatriarch-13-ProjectMatriarch13.mp3",
            "trackLength": "00:04:08",
            "trackDescription": null
          },
          {
            "pK_TrackId": 255,
            "fK_AlbumId": 31,
            "trackNumber": 14,
            "trackTitle": "Project Matriarch 14",
            "trackMP3": "DinoPacifici-MusingsOfAMatriarch-14-ProjectMatriarch14.mp3",
            "trackLength": "00:04:20",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 30,
            "fK_AlbumId": 31,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/musings-of-a-matriarch",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 30,
        "fK_ArtistId": 1,
        "albumTitle": "Dark Artifacts",
        "albumImageCover": "Dino_Pacifici_Dark_Artifacts.jpg",
        "albumImageBack": null,
        "albumLength": "00:58:44",
        "albumStory": null,
        "albumInformation": null,
        "albumCopyright": "2024",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "Dark-Artifacts",
        "albumSortOrder": 3,
        "albumReleaseDate": "2024-04-20T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 231,
            "fK_AlbumId": 30,
            "trackNumber": 1,
            "trackTitle": "Dark Forest Spirits",
            "trackMP3": "DinoPacifici-DarkArtifacts-01-DarkForestSpirits.mp3",
            "trackLength": "00:05:53",
            "trackDescription": null
          },
          {
            "pK_TrackId": 232,
            "fK_AlbumId": 30,
            "trackNumber": 2,
            "trackTitle": "The Enchanted Dark",
            "trackMP3": "DinoPacifici-DarkArtifacts-02-TheEnchantedDark.mp3",
            "trackLength": "00:05:54",
            "trackDescription": null
          },
          {
            "pK_TrackId": 233,
            "fK_AlbumId": 30,
            "trackNumber": 3,
            "trackTitle": "Dark Chocolate",
            "trackMP3": "DinoPacifici-DarkArtifacts-03-DarkChocolate.mp3",
            "trackLength": "00:05:38",
            "trackDescription": null
          },
          {
            "pK_TrackId": 234,
            "fK_AlbumId": 30,
            "trackNumber": 4,
            "trackTitle": "Dark Nebulae",
            "trackMP3": "DinoPacifici-DarkArtifacts-04-DarkNebulae.mp3",
            "trackLength": "00:05:43",
            "trackDescription": null
          },
          {
            "pK_TrackId": 235,
            "fK_AlbumId": 30,
            "trackNumber": 5,
            "trackTitle": "The Dark Arts",
            "trackMP3": "DinoPacifici-DarkArtifacts-05-TheDarkArts.mp3",
            "trackLength": "00:05:02",
            "trackDescription": null
          },
          {
            "pK_TrackId": 236,
            "fK_AlbumId": 30,
            "trackNumber": 6,
            "trackTitle": "Dark Magic",
            "trackMP3": "DinoPacifici-DarkArtifacts-06-DarkMagic.mp3",
            "trackLength": "00:05:08",
            "trackDescription": null
          },
          {
            "pK_TrackId": 237,
            "fK_AlbumId": 30,
            "trackNumber": 7,
            "trackTitle": "Dark Tunnels",
            "trackMP3": "DinoPacifici-DarkArtifacts-07-DarkTunnels.mp3",
            "trackLength": "00:05:48",
            "trackDescription": null
          },
          {
            "pK_TrackId": 238,
            "fK_AlbumId": 30,
            "trackNumber": 8,
            "trackTitle": "Dark Chaos",
            "trackMP3": "DinoPacifici-DarkArtifacts-08-DarkChaos.mp3",
            "trackLength": "00:05:29",
            "trackDescription": null
          },
          {
            "pK_TrackId": 239,
            "fK_AlbumId": 30,
            "trackNumber": 9,
            "trackTitle": "Dark Corners",
            "trackMP3": "DinoPacifici-DarkArtifacts-09-DarkCorners.mp3",
            "trackLength": "00:05:42",
            "trackDescription": null
          },
          {
            "pK_TrackId": 240,
            "fK_AlbumId": 30,
            "trackNumber": 10,
            "trackTitle": "Dark Waters",
            "trackMP3": "DinoPacifici-DarkArtifacts-10-DarkWaters.mp3",
            "trackLength": "00:05:46",
            "trackDescription": null
          },
          {
            "pK_TrackId": 241,
            "fK_AlbumId": 30,
            "trackNumber": 11,
            "trackTitle": "End Of Darkness",
            "trackMP3": "DinoPacifici-DarkArtifacts-11-EndOfDarkness.mp3",
            "trackLength": "00:03:26",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 29,
            "fK_AlbumId": 30,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/dark-artifacts",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 29,
        "fK_ArtistId": 1,
        "albumTitle": "Dante's Other Inferno",
        "albumImageCover": "Dino_Pacifici_Dante's_Other_Inferno.jpg",
        "albumImageBack": null,
        "albumLength": "00:40:27",
        "albumStory": "I have always been a fan of Dante’s Inferno. It’s such a rich, \r\ndescriptive piece with so much going on. I also love Larry Niven’s \r\ntake on the subject with his Inferno novels. This long form piece is \r\nmy take on the hellish scene that is Dante’s Inferno.",
        "albumInformation": null,
        "albumCopyright": "2024",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "Dantes-Other-Inferno",
        "albumSortOrder": 2,
        "albumReleaseDate": "2024-02-23T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 230,
            "fK_AlbumId": 29,
            "trackNumber": 1,
            "trackTitle": "Dante's Other Inferno",
            "trackMP3": "DinoPacifici-Dante'sOtherInferno-01-Dante'sOtherInferno.mp3",
            "trackLength": "00:40:27",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 28,
            "fK_AlbumId": 29,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/dantes-other-inferno",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 28,
        "fK_ArtistId": 1,
        "albumTitle": "A Boat Without Oars",
        "albumImageCover": "Dino_Pacifici_A_Boat_Without_Oars.jpg",
        "albumImageBack": null,
        "albumLength": "01:12:24",
        "albumStory": "The idea behind the album, A Boat Without Oars is, that of being \r\nlost or helpless or not in control. Sometimes we can feel this way \r\nand it hurts to be in that situation, a situation when one has to go \r\nwithout. But, the word “without“ does not always denote the \r\nnegative. As you can surmise with the positive titles of the album, \r\ntracks 4 and 8! There is always hope or someone in another boat \r\nthat will find you",
        "albumInformation": null,
        "albumCopyright": "2024",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "A-Boat-Without-Oars",
        "albumSortOrder": 1,
        "albumReleaseDate": "2024-01-01T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 222,
            "fK_AlbumId": 28,
            "trackNumber": 1,
            "trackTitle": "A Sky Without Stars",
            "trackMP3": "DinoPacifici-ABoatWithoutOars-01-ASkyWithoutStars.mp3",
            "trackLength": "00:11:39",
            "trackDescription": null
          },
          {
            "pK_TrackId": 223,
            "fK_AlbumId": 28,
            "trackNumber": 2,
            "trackTitle": "A Boat Without Oars",
            "trackMP3": "DinoPacifici-ABoatWithoutOars-02-ABoatWithoutOars.mp3",
            "trackLength": "00:11:08",
            "trackDescription": null
          },
          {
            "pK_TrackId": 224,
            "fK_AlbumId": 28,
            "trackNumber": 3,
            "trackTitle": "A Wind Without Direction.",
            "trackMP3": "DinoPacifici-ABoatWithoutOars-03-AWindWithoutDirection.mp3",
            "trackLength": "00:06:54",
            "trackDescription": null
          },
          {
            "pK_TrackId": 225,
            "fK_AlbumId": 28,
            "trackNumber": 4,
            "trackTitle": "A Solitary Moment Without Worry",
            "trackMP3": "DinoPacifici-ABoatWithoutOars-04-ASolitaryMomentWithoutWorry.mp3",
            "trackLength": "00:07:17",
            "trackDescription": null
          },
          {
            "pK_TrackId": 226,
            "fK_AlbumId": 28,
            "trackNumber": 5,
            "trackTitle": "A Clock Without Hands",
            "trackMP3": "DinoPacifici-ABoatWithoutOars-05-AClockWithoutHands.mp3",
            "trackLength": "00:11:34",
            "trackDescription": null
          },
          {
            "pK_TrackId": 227,
            "fK_AlbumId": 28,
            "trackNumber": 6,
            "trackTitle": "A Biosphere Without Life",
            "trackMP3": "DinoPacifici-ABoatWithoutOars-06-ABiosphereWithoutLife.mp3",
            "trackLength": "00:10:16",
            "trackDescription": null
          },
          {
            "pK_TrackId": 228,
            "fK_AlbumId": 28,
            "trackNumber": 7,
            "trackTitle": "A Reef Without Coral",
            "trackMP3": "DinoPacifici-ABoatWithoutOars-07-AReefWithoutCoral.mp3",
            "trackLength": "00:07:40",
            "trackDescription": null
          },
          {
            "pK_TrackId": 229,
            "fK_AlbumId": 28,
            "trackNumber": 8,
            "trackTitle": "A Life Without Limits",
            "trackMP3": "DinoPacifici-ABoatWithoutOars-08-ALifeWithoutLimits.mp3",
            "trackLength": "00:05:53",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 27,
            "fK_AlbumId": 28,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/a-boat-without-oars",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 27,
        "fK_ArtistId": 1,
        "albumTitle": "Too Many Miles..",
        "albumImageCover": "Dino_Pacifici_Too_Many_Miles.jpg",
        "albumImageBack": null,
        "albumLength": "00:52:51",
        "albumStory": "This album was recorded over a few years time and was originally released in 2018 with 11 tracks.  The 2023 version is remastered and has 14 tracks. I do enjoy writing lyrics and putting them to music once in a while. This is a compilation of songs I wrote and performed in the pop/rock/R&B styles with influences from Steely Dan to James Taylor, Fleetwood Mac, Doobie Bros, etc. I grew up in the 70's 80's. Best time IMO :)",
        "albumInformation": "All songs written, recorded and performed by Dino Pacifici.",
        "albumCopyright": "2023",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Rock",
        "albumFriendlyUrl": "Too-Many-Miles",
        "albumSortOrder": 4,
        "albumReleaseDate": "2023-08-23T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 208,
            "fK_AlbumId": 27,
            "trackNumber": 1,
            "trackTitle": "Stop",
            "trackMP3": "DinoPacifici-TooManyMiles-01-Stop.mp3",
            "trackLength": "00:03:40",
            "trackDescription": null
          },
          {
            "pK_TrackId": 209,
            "fK_AlbumId": 27,
            "trackNumber": 2,
            "trackTitle": "It's 'Cus Of You",
            "trackMP3": "DinoPacifici-TooManyMiles-02-It's'CusOfYou.mp3",
            "trackLength": "00:03:23",
            "trackDescription": null
          },
          {
            "pK_TrackId": 210,
            "fK_AlbumId": 27,
            "trackNumber": 3,
            "trackTitle": "The Future City",
            "trackMP3": "DinoPacifici-TooManyMiles-03-TheFutureCity.mp3",
            "trackLength": "00:03:57",
            "trackDescription": null
          },
          {
            "pK_TrackId": 211,
            "fK_AlbumId": 27,
            "trackNumber": 4,
            "trackTitle": "Learn To See",
            "trackMP3": "DinoPacifici-TooManyMiles-04-LearnToSee.mp3",
            "trackLength": "00:03:44",
            "trackDescription": null
          },
          {
            "pK_TrackId": 212,
            "fK_AlbumId": 27,
            "trackNumber": 5,
            "trackTitle": "Get Tough",
            "trackMP3": "DinoPacifici-TooManyMiles-05-GetTough.mp3",
            "trackLength": "00:04:17",
            "trackDescription": null
          },
          {
            "pK_TrackId": 213,
            "fK_AlbumId": 27,
            "trackNumber": 6,
            "trackTitle": "Save Me (From Myself)",
            "trackMP3": "DinoPacifici-TooManyMiles-06-SaveMe(FromMyself).mp3",
            "trackLength": "00:03:27",
            "trackDescription": null
          },
          {
            "pK_TrackId": 214,
            "fK_AlbumId": 27,
            "trackNumber": 7,
            "trackTitle": "Opression/Recession",
            "trackMP3": "DinoPacifici-TooManyMiles-07-Opression_Recession.mp3",
            "trackLength": "00:03:30",
            "trackDescription": null
          },
          {
            "pK_TrackId": 215,
            "fK_AlbumId": 27,
            "trackNumber": 8,
            "trackTitle": "Too Many Miles",
            "trackMP3": "DinoPacifici-TooManyMiles-08-TooManyMiles.mp3",
            "trackLength": "00:03:15",
            "trackDescription": null
          },
          {
            "pK_TrackId": 216,
            "fK_AlbumId": 27,
            "trackNumber": 9,
            "trackTitle": "Summer Sun",
            "trackMP3": "DinoPacifici-TooManyMiles-09-SummerSun.mp3",
            "trackLength": "00:03:58",
            "trackDescription": null
          },
          {
            "pK_TrackId": 217,
            "fK_AlbumId": 27,
            "trackNumber": 10,
            "trackTitle": "Roll Of The Dice",
            "trackMP3": "DinoPacifici-TooManyMiles-10-RollOfTheDice.mp3",
            "trackLength": "00:04:38",
            "trackDescription": null
          },
          {
            "pK_TrackId": 218,
            "fK_AlbumId": 27,
            "trackNumber": 11,
            "trackTitle": "Sometimes In The Long Run",
            "trackMP3": "DinoPacifici-TooManyMiles-11-SometimesInTheLongRun.mp3",
            "trackLength": "00:03:22",
            "trackDescription": null
          },
          {
            "pK_TrackId": 219,
            "fK_AlbumId": 27,
            "trackNumber": 12,
            "trackTitle": "My Attention",
            "trackMP3": "DinoPacifici-TooManyMiles-12-MyAttention.mp3",
            "trackLength": "00:03:12",
            "trackDescription": null
          },
          {
            "pK_TrackId": 220,
            "fK_AlbumId": 27,
            "trackNumber": 13,
            "trackTitle": "I Want To Be Free",
            "trackMP3": "DinoPacifici-TooManyMiles-13-IWantToBeFree.mp3",
            "trackLength": "00:03:54",
            "trackDescription": null
          },
          {
            "pK_TrackId": 221,
            "fK_AlbumId": 27,
            "trackNumber": 14,
            "trackTitle": "Do You Know?",
            "trackMP3": "DinoPacifici-TooManyMiles-14-DoYouKnow_.mp3",
            "trackLength": "00:04:28",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 1,
            "fK_AlbumId": 27,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/too-many-miles",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 25,
        "fK_ArtistId": 1,
        "albumTitle": "Kinetic N-R-Gee",
        "albumImageCover": "Dino_Pacifici_Kinetic_N-R-Gee_Front.jpg",
        "albumImageBack": null,
        "albumLength": "00:52:42",
        "albumStory": "The album is about modes of transportation transposed into music. The art of motion.",
        "albumInformation": null,
        "albumCopyright": "2023",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "Kinetic-N-R-Gee",
        "albumSortOrder": 3,
        "albumReleaseDate": "2023-07-26T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 192,
            "fK_AlbumId": 25,
            "trackNumber": 1,
            "trackTitle": "The Tall Ship",
            "trackMP3": "DinoPacifici-KineticN-R-Gee-01-TheTallShip.mp3",
            "trackLength": "00:10:26",
            "trackDescription": null
          },
          {
            "pK_TrackId": 193,
            "fK_AlbumId": 25,
            "trackNumber": 2,
            "trackTitle": "The Submarine",
            "trackMP3": "DinoPacifici-KineticN-R-Gee-02-TheSubmarine.mp3",
            "trackLength": "00:06:44",
            "trackDescription": null
          },
          {
            "pK_TrackId": 194,
            "fK_AlbumId": 25,
            "trackNumber": 3,
            "trackTitle": "The Airship",
            "trackMP3": "DinoPacifici-KineticN-R-Gee-03-TheAirship.mp3",
            "trackLength": "00:08:58",
            "trackDescription": null
          },
          {
            "pK_TrackId": 195,
            "fK_AlbumId": 25,
            "trackNumber": 4,
            "trackTitle": "The Hot Air Balloon",
            "trackMP3": "DinoPacifici-KineticN-R-Gee-04-TheHotAirBalloon.mp3",
            "trackLength": "00:05:33",
            "trackDescription": null
          },
          {
            "pK_TrackId": 196,
            "fK_AlbumId": 25,
            "trackNumber": 5,
            "trackTitle": "The Chinese Junk",
            "trackMP3": "DinoPacifici-KineticN-R-Gee-05-TheChineseJunk.mp3",
            "trackLength": "00:07:12",
            "trackDescription": null
          },
          {
            "pK_TrackId": 197,
            "fK_AlbumId": 25,
            "trackNumber": 6,
            "trackTitle": "The Bicycle",
            "trackMP3": "DinoPacifici-KineticN-R-Gee-06-TheBicycle.mp3",
            "trackLength": "00:06:36",
            "trackDescription": null
          },
          {
            "pK_TrackId": 198,
            "fK_AlbumId": 25,
            "trackNumber": 7,
            "trackTitle": "The Bullet Train",
            "trackMP3": "DinoPacifici-KineticN-R-Gee-07-TheBulletTrain.mp3",
            "trackLength": "00:07:11",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 2,
            "fK_AlbumId": 25,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/kinetic-n-r-gee",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 23,
        "fK_ArtistId": 1,
        "albumTitle": "Spaceman's Lament",
        "albumImageCover": "Dino_Pacifici_Spaceman's_Lament_Front.jpg",
        "albumImageBack": null,
        "albumLength": "00:54:10",
        "albumStory": "A story of a traveller lost and then found...",
        "albumInformation": null,
        "albumCopyright": "2023",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "Spacemans-Lament",
        "albumSortOrder": 2,
        "albumReleaseDate": "2023-03-11T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 176,
            "fK_AlbumId": 23,
            "trackNumber": 1,
            "trackTitle": "Spaceman's Lament",
            "trackMP3": "DinoPacifici-Spaceman'sLament-01-Spaceman'sLament.mp3",
            "trackLength": "00:11:27",
            "trackDescription": null
          },
          {
            "pK_TrackId": 177,
            "fK_AlbumId": 23,
            "trackNumber": 2,
            "trackTitle": "Drifting In The Abyss",
            "trackMP3": "DinoPacifici-Spaceman'sLament-02-DriftingInTheAbyss.mp3",
            "trackLength": "00:10:34",
            "trackDescription": null
          },
          {
            "pK_TrackId": 178,
            "fK_AlbumId": 23,
            "trackNumber": 3,
            "trackTitle": "Distress Signal",
            "trackMP3": "DinoPacifici-Spaceman'sLament-03-DistressSignal.mp3",
            "trackLength": "00:09:30",
            "trackDescription": null
          },
          {
            "pK_TrackId": 179,
            "fK_AlbumId": 23,
            "trackNumber": 4,
            "trackTitle": "Cry In The Dark",
            "trackMP3": "DinoPacifici-Spaceman'sLament-04-CryInTheDark.mp3",
            "trackLength": "00:09:44",
            "trackDescription": null
          },
          {
            "pK_TrackId": 180,
            "fK_AlbumId": 23,
            "trackNumber": 5,
            "trackTitle": "Home Star Coordinates Confirmed - Homeward Bound",
            "trackMP3": "DinoPacifici-Spaceman'sLament-05-HomeStarCoordinatesConfirmed-HomewardBound.mp3",
            "trackLength": "00:06:21",
            "trackDescription": null
          },
          {
            "pK_TrackId": 181,
            "fK_AlbumId": 23,
            "trackNumber": 6,
            "trackTitle": "Reaching Home At Last",
            "trackMP3": "DinoPacifici-Spaceman'sLament-06-ReachingHomeAtLast.mp3",
            "trackLength": "00:06:41",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 5,
            "fK_AlbumId": 23,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/spacemans-lament",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 22,
        "fK_ArtistId": 1,
        "albumTitle": "New Earth",
        "albumImageCover": "Dino_Pacifici_New_Earth_Front.jpg",
        "albumImageBack": null,
        "albumLength": "00:45:23",
        "albumStory": "My first foray into Neo-Classical music.",
        "albumInformation": null,
        "albumCopyright": "2023",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Neo-Classical",
        "albumFriendlyUrl": "New-Earth",
        "albumSortOrder": 1,
        "albumReleaseDate": "2023-02-10T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 161,
            "fK_AlbumId": 22,
            "trackNumber": 1,
            "trackTitle": "New Earth - Movement 1",
            "trackMP3": "DinoPacifici-NewEarth-01-NewEarth-Movement1.mp3",
            "trackLength": "00:03:07",
            "trackDescription": null
          },
          {
            "pK_TrackId": 162,
            "fK_AlbumId": 22,
            "trackNumber": 2,
            "trackTitle": "New Earth - Movement 2",
            "trackMP3": "DinoPacifici-NewEarth-02-NewEarth-Movement2.mp3",
            "trackLength": "00:03:18",
            "trackDescription": null
          },
          {
            "pK_TrackId": 163,
            "fK_AlbumId": 22,
            "trackNumber": 3,
            "trackTitle": "New Earth - Movement 3",
            "trackMP3": "DinoPacifici-NewEarth-03-NewEarth-Movement3.mp3",
            "trackLength": "00:03:34",
            "trackDescription": null
          },
          {
            "pK_TrackId": 164,
            "fK_AlbumId": 22,
            "trackNumber": 4,
            "trackTitle": "New Earth - Movement 4",
            "trackMP3": "DinoPacifici-NewEarth-04-NewEarth-Movement4.mp3",
            "trackLength": "00:02:13",
            "trackDescription": null
          },
          {
            "pK_TrackId": 165,
            "fK_AlbumId": 22,
            "trackNumber": 5,
            "trackTitle": "New Earth - Movement 5",
            "trackMP3": "DinoPacifici-NewEarth-05-NewEarth-Movement5.mp3",
            "trackLength": "00:02:20",
            "trackDescription": null
          },
          {
            "pK_TrackId": 166,
            "fK_AlbumId": 22,
            "trackNumber": 6,
            "trackTitle": "New Earth - Movement 6",
            "trackMP3": "DinoPacifici-NewEarth-06-NewEarth-Movement6.mp3",
            "trackLength": "00:02:21",
            "trackDescription": null
          },
          {
            "pK_TrackId": 167,
            "fK_AlbumId": 22,
            "trackNumber": 7,
            "trackTitle": "New Earth - Movement 7",
            "trackMP3": "DinoPacifici-NewEarth-07-NewEarth-Movement7.mp3",
            "trackLength": "00:03:21",
            "trackDescription": null
          },
          {
            "pK_TrackId": 168,
            "fK_AlbumId": 22,
            "trackNumber": 8,
            "trackTitle": "New Earth - Movement 8",
            "trackMP3": "DinoPacifici-NewEarth-08-NewEarth-Movement8.mp3",
            "trackLength": "00:02:31",
            "trackDescription": null
          },
          {
            "pK_TrackId": 169,
            "fK_AlbumId": 22,
            "trackNumber": 9,
            "trackTitle": "New Earth - Movement 9",
            "trackMP3": "DinoPacifici-NewEarth-09-NewEarth-Movement9.mp3",
            "trackLength": "00:03:39",
            "trackDescription": null
          },
          {
            "pK_TrackId": 170,
            "fK_AlbumId": 22,
            "trackNumber": 10,
            "trackTitle": "New Earth - Movement 10",
            "trackMP3": "DinoPacifici-NewEarth-10-NewEarth-Movement10.mp3",
            "trackLength": "00:03:46",
            "trackDescription": null
          },
          {
            "pK_TrackId": 171,
            "fK_AlbumId": 22,
            "trackNumber": 11,
            "trackTitle": "New Earth - Movement 11",
            "trackMP3": "DinoPacifici-NewEarth-11-NewEarth-Movement11.mp3",
            "trackLength": "00:02:14",
            "trackDescription": null
          },
          {
            "pK_TrackId": 172,
            "fK_AlbumId": 22,
            "trackNumber": 12,
            "trackTitle": "New Earth - Movement 12",
            "trackMP3": "DinoPacifici-NewEarth-12-NewEarth-Movement12.mp3",
            "trackLength": "00:03:22",
            "trackDescription": null
          },
          {
            "pK_TrackId": 173,
            "fK_AlbumId": 22,
            "trackNumber": 13,
            "trackTitle": "New Earth - Movement 13",
            "trackMP3": "DinoPacifici-NewEarth-13-NewEarth-Movement13.mp3",
            "trackLength": "00:03:49",
            "trackDescription": null
          },
          {
            "pK_TrackId": 174,
            "fK_AlbumId": 22,
            "trackNumber": 14,
            "trackTitle": "New Earth - Movement 14",
            "trackMP3": "DinoPacifici-NewEarth-14-NewEarth-Movement14.mp3",
            "trackLength": "00:02:18",
            "trackDescription": null
          },
          {
            "pK_TrackId": 175,
            "fK_AlbumId": 22,
            "trackNumber": 15,
            "trackTitle": "New Earth - Movement 15",
            "trackMP3": "DinoPacifici-NewEarth-15-NewEarth-Movement15.mp3",
            "trackLength": "00:03:22",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 6,
            "fK_AlbumId": 22,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/new-earth",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 21,
        "fK_ArtistId": 1,
        "albumTitle": "Geo​-​Ambient Excursions",
        "albumImageCover": "Dino_Pacifici_Geo-Ambient_Excursions_Front.jpg",
        "albumImageBack": null,
        "albumLength": "00:59:12",
        "albumStory": "Travel using music as a mode of transportation. My impressions of places around the world. I have had the incredible chance of experiencing going around the world twice. It was a sublime feeling landing in so many ports of call and experiencing the cultures so different in some ways and yet, so similar. Travel is the great educator. Enjoy the voyage!",
        "albumInformation": "Composed, performed, recorded, mixed and mastered by Dino Pacivfici.  Cover concept: Claire Molson. Cover photo: Dino Pacifici.",
        "albumCopyright": "2023",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "Geo-Ambient-Excursions",
        "albumSortOrder": 0,
        "albumReleaseDate": "2023-01-01T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 151,
            "fK_AlbumId": 21,
            "trackNumber": 1,
            "trackTitle": "London Rains",
            "trackMP3": "DinoPacifici-Geo-AmbientExcursions-01-LondonRains.mp3",
            "trackLength": "00:07:07",
            "trackDescription": null
          },
          {
            "pK_TrackId": 152,
            "fK_AlbumId": 21,
            "trackNumber": 2,
            "trackTitle": "Arctic Sky",
            "trackMP3": "DinoPacifici-Geo-AmbientExcursions-02-ArcticSky.mp3",
            "trackLength": "00:06:13",
            "trackDescription": null
          },
          {
            "pK_TrackId": 153,
            "fK_AlbumId": 21,
            "trackNumber": 3,
            "trackTitle": "Romanian Midnight",
            "trackMP3": "DinoPacifici-Geo-AmbientExcursions-03-RomanianMidnight.mp3",
            "trackLength": "00:04:34",
            "trackDescription": null
          },
          {
            "pK_TrackId": 154,
            "fK_AlbumId": 21,
            "trackNumber": 4,
            "trackTitle": "Ibiza Street",
            "trackMP3": "DinoPacifici-Geo-AmbientExcursions-04-IbizaStreets.mp3",
            "trackLength": "00:06:11",
            "trackDescription": null
          },
          {
            "pK_TrackId": 155,
            "fK_AlbumId": 21,
            "trackNumber": 5,
            "trackTitle": "Echoes Of Zanzibar",
            "trackMP3": "DinoPacifici-Geo-AmbientExcursions-05-EchoesOfZanzibar.mp3",
            "trackLength": "00:08:13",
            "trackDescription": null
          },
          {
            "pK_TrackId": 156,
            "fK_AlbumId": 21,
            "trackNumber": 6,
            "trackTitle": "Barrin Island Chill",
            "trackMP3": "DinoPacifici-Geo-AmbientExcursions-06-BaffinIslandChill.mp3",
            "trackLength": "00:05:11",
            "trackDescription": null
          },
          {
            "pK_TrackId": 157,
            "fK_AlbumId": 21,
            "trackNumber": 7,
            "trackTitle": "Brazilian Beach Time / Rio 1885",
            "trackMP3": "DinoPacifici-Geo-AmbientExcursions-07-BrazilianBeachTime-Rio1885.mp3",
            "trackLength": "00:04:48",
            "trackDescription": null
          },
          {
            "pK_TrackId": 158,
            "fK_AlbumId": 21,
            "trackNumber": 8,
            "trackTitle": "The Jungles Of Borneo",
            "trackMP3": "DinoPacifici-Geo-AmbientExcursions-08-TheJunglesOfBorneo.mp3",
            "trackLength": "00:05:16",
            "trackDescription": null
          },
          {
            "pK_TrackId": 159,
            "fK_AlbumId": 21,
            "trackNumber": 9,
            "trackTitle": "Cape Horn - The Meeting Of The Oceans",
            "trackMP3": "DinoPacifici-Geo-AmbientExcursions-09-CapeHorn-TheMeetingOfTheOceans.mp3",
            "trackLength": "00:06:30",
            "trackDescription": null
          },
          {
            "pK_TrackId": 160,
            "fK_AlbumId": 21,
            "trackNumber": 10,
            "trackTitle": "The Winds Of Everest",
            "trackMP3": "DinoPacifici-Geo-AmbientExcursions-10-TheWindsOfEverest.mp3",
            "trackLength": "00:05:05",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 7,
            "fK_AlbumId": 21,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/geo-ambient-excursions",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 20,
        "fK_ArtistId": 1,
        "albumTitle": "Day's End",
        "albumImageCover": "Dino_Pacifici_Day's_End_Front.jpg",
        "albumImageBack": null,
        "albumLength": "00:43:56",
        "albumStory": "Two long form pieces of meditative, relaxing and ambient music.",
        "albumInformation": "Composed, performed and recorded by Dino Pacifici",
        "albumCopyright": "2022",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "Days-End",
        "albumSortOrder": 4,
        "albumReleaseDate": "2022-09-01T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 149,
            "fK_AlbumId": 20,
            "trackNumber": 1,
            "trackTitle": "Musings...",
            "trackMP3": "DinoPacifici-Day'sEnd-01-Musings....mp3",
            "trackLength": "00:20:59",
            "trackDescription": null
          },
          {
            "pK_TrackId": 150,
            "fK_AlbumId": 20,
            "trackNumber": 2,
            "trackTitle": "Long Shadows, Day's End",
            "trackMP3": "DinoPacifici-Day'sEnd-02-LongShadows,Day'sEnd.mp3",
            "trackLength": "00:22:58",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 8,
            "fK_AlbumId": 20,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/days-end",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 19,
        "fK_ArtistId": 1,
        "albumTitle": "Untitled 47",
        "albumImageCover": "Dino_Pacifici_Untitled_47_Front.jpg",
        "albumImageBack": null,
        "albumLength": "0:47:19",
        "albumStory": "A track from the past. Don't remember when I actually did this one.",
        "albumInformation": "Composed, performed, recorded and arranged by Dino Pacifici",
        "albumCopyright": "2022",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "Untitled-47",
        "albumSortOrder": 3,
        "albumReleaseDate": "2022-07-08T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 148,
            "fK_AlbumId": 19,
            "trackNumber": 1,
            "trackTitle": "Untitled 47",
            "trackMP3": "DinoPacifici-Untitled47-01-Untitled47.mp3",
            "trackLength": "00:47:19",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 9,
            "fK_AlbumId": 19,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/untitled-47",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 18,
        "fK_ArtistId": 1,
        "albumTitle": "Life Rhythms - Orphans Vol. 2",
        "albumImageCover": "Dino_Pacifici_Life_Rhythms_Front.jpg",
        "albumImageBack": null,
        "albumLength": "00:38:14",
        "albumStory": null,
        "albumInformation": "Composed, arranged, performed and recorded by Dino Pacifici",
        "albumCopyright": "2022",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "Life-Rhythms-Orphans-Vol-2",
        "albumSortOrder": 2,
        "albumReleaseDate": "2022-06-29T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 141,
            "fK_AlbumId": 18,
            "trackNumber": 1,
            "trackTitle": "Barry's Bay",
            "trackMP3": "DinoPacifici-LifeRhythms-OrphansVol.2-01-Barry'sBay.mp3",
            "trackLength": "00:04:30",
            "trackDescription": null
          },
          {
            "pK_TrackId": 142,
            "fK_AlbumId": 18,
            "trackNumber": 2,
            "trackTitle": "Hypnos",
            "trackMP3": "DinoPacifici-LifeRhythms-OrphansVol.2-02-Hypnos.mp3",
            "trackLength": "00:05:06",
            "trackDescription": null
          },
          {
            "pK_TrackId": 143,
            "fK_AlbumId": 18,
            "trackNumber": 3,
            "trackTitle": "Classique",
            "trackMP3": "DinoPacifici-LifeRhythms-OrphansVol.2-03-Classique.mp3",
            "trackLength": "00:06:13",
            "trackDescription": null
          },
          {
            "pK_TrackId": 144,
            "fK_AlbumId": 18,
            "trackNumber": 4,
            "trackTitle": "Ancient History",
            "trackMP3": "DinoPacifici-LifeRhythms-OrphansVol.2-04-AncientHistory.mp3",
            "trackLength": "00:06:36",
            "trackDescription": null
          },
          {
            "pK_TrackId": 145,
            "fK_AlbumId": 18,
            "trackNumber": 5,
            "trackTitle": "And The Children Shall Lead",
            "trackMP3": "DinoPacifici-LifeRhythms-OrphansVol.2-05-AndTheChildrenShallLead.mp3",
            "trackLength": "00:04:49",
            "trackDescription": null
          },
          {
            "pK_TrackId": 146,
            "fK_AlbumId": 18,
            "trackNumber": 6,
            "trackTitle": "And So It Goes",
            "trackMP3": "DinoPacifici-LifeRhythms-OrphansVol.2-06-AndSoItGoes.mp3",
            "trackLength": "00:05:41",
            "trackDescription": null
          },
          {
            "pK_TrackId": 147,
            "fK_AlbumId": 18,
            "trackNumber": 7,
            "trackTitle": "Summer's End",
            "trackMP3": "DinoPacifici-LifeRhythms-OrphansVol.2-07-Summer'sEnd.mp3",
            "trackLength": "00:05:15",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 10,
            "fK_AlbumId": 18,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/life-rhythms-orphans-vol-2",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 17,
        "fK_ArtistId": 1,
        "albumTitle": "October Ambience",
        "albumImageCover": "Dino_Pacifici_October_Ambience_Front.jpg",
        "albumImageBack": null,
        "albumLength": "01:00:14",
        "albumStory": "A one hour relaxation track ",
        "albumInformation": "Composed, recorded and performed by Dino Pacifici. Released June 17, 2022",
        "albumCopyright": "2022",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "October-Ambience",
        "albumSortOrder": 1,
        "albumReleaseDate": "2022-06-17T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 140,
            "fK_AlbumId": 17,
            "trackNumber": 1,
            "trackTitle": "October Ambience",
            "trackMP3": "DinoPacifici-OctoberAmbience-01-OctoberAmbience.mp3",
            "trackLength": "01:00:14",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 11,
            "fK_AlbumId": 17,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/october-ambience",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 16,
        "fK_ArtistId": 1,
        "albumTitle": "Longing...",
        "albumImageCover": "Dino_Pacifici_Longing_Front.jpg",
        "albumImageBack": null,
        "albumLength": "01:01:58",
        "albumStory": "LONGING... is a strong desire especially for something unattainable : craving, a feeling of wanting something or someone very much, a strong feeling of need, having or showing a yearning desire.",
        "albumInformation": "Composed, performed and recorded by Dino Pacifici. Dino uses a Macbook Pro with Logic Pro software, Native Instruments, Kontakt, Roland JX-10, Yamaha DX7, Fender Rhodes 73, going through UAD Apollo 8 and Wave plugins, etc... Released April 20, 2022",
        "albumCopyright": "2022",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "Longing",
        "albumSortOrder": 0,
        "albumReleaseDate": "2022-04-20T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 130,
            "fK_AlbumId": 16,
            "trackNumber": 1,
            "trackTitle": "Longing For...",
            "trackMP3": "DinoPacifici-Longing...-01-LongingFor....mp3",
            "trackLength": "00:07:14",
            "trackDescription": null
          },
          {
            "pK_TrackId": 131,
            "fK_AlbumId": 16,
            "trackNumber": 2,
            "trackTitle": "Longing To...",
            "trackMP3": "DinoPacifici-Longing...-02-LongingTo....mp3",
            "trackLength": "00:07:18",
            "trackDescription": null
          },
          {
            "pK_TrackId": 132,
            "fK_AlbumId": 16,
            "trackNumber": 3,
            "trackTitle": "Longing As...",
            "trackMP3": "DinoPacifici-Longing...-03-LongingAs....mp3",
            "trackLength": "00:04:23",
            "trackDescription": null
          },
          {
            "pK_TrackId": 133,
            "fK_AlbumId": 16,
            "trackNumber": 4,
            "trackTitle": "Longing Has...",
            "trackMP3": "DinoPacifici-Longing...-04-LongingHas....mp3",
            "trackLength": "00:05:26",
            "trackDescription": null
          },
          {
            "pK_TrackId": 134,
            "fK_AlbumId": 16,
            "trackNumber": 5,
            "trackTitle": "Longing Is...",
            "trackMP3": "DinoPacifici-Longing...-05-LongingIs....mp3",
            "trackLength": "00:05:39",
            "trackDescription": null
          },
          {
            "pK_TrackId": 135,
            "fK_AlbumId": 16,
            "trackNumber": 6,
            "trackTitle": "Longing And...",
            "trackMP3": "DinoPacifici-Longing...-06-LongingAnd....mp3",
            "trackLength": "00:05:49",
            "trackDescription": null
          },
          {
            "pK_TrackId": 136,
            "fK_AlbumId": 16,
            "trackNumber": 7,
            "trackTitle": "Longing Alas...",
            "trackMP3": "DinoPacifici-Longing...-07-LongingAlas....mp3",
            "trackLength": "00:05:11",
            "trackDescription": null
          },
          {
            "pK_TrackId": 137,
            "fK_AlbumId": 16,
            "trackNumber": 8,
            "trackTitle": "Longing So...",
            "trackMP3": "DinoPacifici-Longing...-08-LongingSo....mp3",
            "trackLength": "00:06:27",
            "trackDescription": null
          },
          {
            "pK_TrackId": 138,
            "fK_AlbumId": 16,
            "trackNumber": 9,
            "trackTitle": "Longing Since...",
            "trackMP3": "DinoPacifici-Longing...-09-LongingSince....mp3",
            "trackLength": "00:07:29",
            "trackDescription": null
          },
          {
            "pK_TrackId": 139,
            "fK_AlbumId": 16,
            "trackNumber": 10,
            "trackTitle": "Longing After...",
            "trackMP3": "DinoPacifici-Longing...-10-LongingAfter....mp3",
            "trackLength": "00:06:57",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 12,
            "fK_AlbumId": 16,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/longing",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 15,
        "fK_ArtistId": 1,
        "albumTitle": "Groove Fragments",
        "albumImageCover": "Dino_Pacifici_Groove_Fragments_Front.jpg",
        "albumImageBack": null,
        "albumLength": "00:42:24",
        "albumStory": "Groove Fragments is: summertime, friends, blue skies, chill, happy, sad, hopeful, with a smile or a tear, bar-hopping, sailing, coming into the light from the darkness, love, separation, music to sway or dance by, it's this and it's that.....",
        "albumInformation": "Music and lyrics: Dino Pacifici. Performed by: dee-p",
        "albumCopyright": "2021",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Pop",
        "albumFriendlyUrl": "Groove-Fragments",
        "albumSortOrder": 1,
        "albumReleaseDate": "2021-06-04T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 120,
            "fK_AlbumId": 15,
            "trackNumber": 1,
            "trackTitle": "Come To Me",
            "trackMP3": "DinoPacifici-GrooveFragments-01-ComeToMe.mp3",
            "trackLength": "00:03:45",
            "trackDescription": null
          },
          {
            "pK_TrackId": 121,
            "fK_AlbumId": 15,
            "trackNumber": 2,
            "trackTitle": "It's The Summertime",
            "trackMP3": "DinoPacifici-GrooveFragments-02-It'sTheSummertime.mp3",
            "trackLength": "00:04:29",
            "trackDescription": null
          },
          {
            "pK_TrackId": 122,
            "fK_AlbumId": 15,
            "trackNumber": 3,
            "trackTitle": "Cabin Fever",
            "trackMP3": "DinoPacifici-GrooveFragments-03-CabinFever.mp3",
            "trackLength": "00:03:17",
            "trackDescription": null
          },
          {
            "pK_TrackId": 123,
            "fK_AlbumId": 15,
            "trackNumber": 4,
            "trackTitle": "Twilight Time",
            "trackMP3": "DinoPacifici-GrooveFragments-04-TwilightTime.mp3",
            "trackLength": "00:03:45",
            "trackDescription": null
          },
          {
            "pK_TrackId": 124,
            "fK_AlbumId": 15,
            "trackNumber": 5,
            "trackTitle": "Gonna Paint The Town Red",
            "trackMP3": "DinoPacifici-GrooveFragments-05-GonnaPaintTheTownRed.mp3",
            "trackLength": "00:04:21",
            "trackDescription": null
          },
          {
            "pK_TrackId": 125,
            "fK_AlbumId": 15,
            "trackNumber": 6,
            "trackTitle": "You Were Already Gone",
            "trackMP3": "DinoPacifici-GrooveFragments-06-YouWereAlreadyGone.mp3",
            "trackLength": "00:04:42",
            "trackDescription": null
          },
          {
            "pK_TrackId": 126,
            "fK_AlbumId": 15,
            "trackNumber": 7,
            "trackTitle": "One With The Night",
            "trackMP3": "DinoPacifici-GrooveFragments-07-OneWithTheNight.mp3",
            "trackLength": "00:04:33",
            "trackDescription": null
          },
          {
            "pK_TrackId": 127,
            "fK_AlbumId": 15,
            "trackNumber": 8,
            "trackTitle": "Layers Of Confusion",
            "trackMP3": "DinoPacifici-GrooveFragments-08-LayersOfConfusion.mp3",
            "trackLength": "00:04:10",
            "trackDescription": null
          },
          {
            "pK_TrackId": 128,
            "fK_AlbumId": 15,
            "trackNumber": 9,
            "trackTitle": "Little Blue Pill",
            "trackMP3": "DinoPacifici-GrooveFragments-09-LittleBluePill.mp3",
            "trackLength": "00:04:58",
            "trackDescription": null
          },
          {
            "pK_TrackId": 129,
            "fK_AlbumId": 15,
            "trackNumber": 10,
            "trackTitle": "Hop On",
            "trackMP3": "DinoPacifici-GrooveFragments-10-HopOn.mp3",
            "trackLength": "00:04:20",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 13,
            "fK_AlbumId": 15,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/groove-fragments",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 14,
        "fK_ArtistId": 1,
        "albumTitle": "Celestial Anomalies",
        "albumImageCover": "Dino_Pacifici_Celestial_Anomalies_Front.jpg",
        "albumImageBack": null,
        "albumLength": "01:00:13",
        "albumStory": "A journey to the far reaches of the universe filled with adventure and a smooth return home..",
        "albumInformation": "Composed, produced and performed by: Dino Pacifici. Released January 26, 2021",
        "albumCopyright": "2021",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "Celestial-Anomalies",
        "albumSortOrder": 0,
        "albumReleaseDate": "2021-01-26T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 110,
            "fK_AlbumId": 14,
            "trackNumber": 1,
            "trackTitle": "Celestial Anomalies",
            "trackMP3": "DinoPacifici-CelestialAnomalies-01-CelestialAnomalies.mp3",
            "trackLength": "00:05:15",
            "trackDescription": null
          },
          {
            "pK_TrackId": 111,
            "fK_AlbumId": 14,
            "trackNumber": 2,
            "trackTitle": "Light Years From Home",
            "trackMP3": "DinoPacifici-CelestialAnomalies-02-LightYearsfromHome.mp3",
            "trackLength": "00:05:18",
            "trackDescription": null
          },
          {
            "pK_TrackId": 112,
            "fK_AlbumId": 14,
            "trackNumber": 3,
            "trackTitle": "Voices From The Nebula",
            "trackMP3": "DinoPacifici-CelestialAnomalies-03-VoicesFromTheNebula.mp3",
            "trackLength": "00:06:45",
            "trackDescription": null
          },
          {
            "pK_TrackId": 113,
            "fK_AlbumId": 14,
            "trackNumber": 4,
            "trackTitle": "Particle Transmissions",
            "trackMP3": "DinoPacifici-CelestialAnomalies-04-ParticleTransmissions.mp3",
            "trackLength": "00:05:57",
            "trackDescription": null
          },
          {
            "pK_TrackId": 114,
            "fK_AlbumId": 14,
            "trackNumber": 5,
            "trackTitle": "Surfing On The Solar Wind",
            "trackMP3": "DinoPacifici-CelestialAnomalies-05-SurfingOnTheSolarWind.mp3",
            "trackLength": "00:08:00",
            "trackDescription": null
          },
          {
            "pK_TrackId": 115,
            "fK_AlbumId": 14,
            "trackNumber": 6,
            "trackTitle": "Dance Of The Twin Suns",
            "trackMP3": "DinoPacifici-CelestialAnomalies-06-DanceOfTheTwinSuns.mp3",
            "trackLength": "00:05:00",
            "trackDescription": null
          },
          {
            "pK_TrackId": 116,
            "fK_AlbumId": 14,
            "trackNumber": 7,
            "trackTitle": "Peaceful Void",
            "trackMP3": "DinoPacifici-CelestialAnomalies-07-PeacefulVoid.mp3",
            "trackLength": "00:06:38",
            "trackDescription": null
          },
          {
            "pK_TrackId": 117,
            "fK_AlbumId": 14,
            "trackNumber": 8,
            "trackTitle": "Galactic Drift",
            "trackMP3": "DinoPacifici-CelestialAnomalies-08-GalacticDrift.mp3",
            "trackLength": "00:05:58",
            "trackDescription": null
          },
          {
            "pK_TrackId": 118,
            "fK_AlbumId": 14,
            "trackNumber": 9,
            "trackTitle": "Docking Sequence",
            "trackMP3": "DinoPacifici-CelestialAnomalies-09-DockingSequence.mp3",
            "trackLength": "00:06:41",
            "trackDescription": null
          },
          {
            "pK_TrackId": 119,
            "fK_AlbumId": 14,
            "trackNumber": 10,
            "trackTitle": "Journey's End",
            "trackMP3": "DinoPacifici-CelestialAnomalies-10-Journey'sEnd.mp3",
            "trackLength": "00:04:39",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 14,
            "fK_AlbumId": 14,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/celestial-anomalies",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 13,
        "fK_ArtistId": 1,
        "albumTitle": "The Ambient Garden",
        "albumImageCover": "Dino_Pacifici_The_Ambient_Garden_Front.jpg",
        "albumImageBack": null,
        "albumLength": "01:02:19",
        "albumStory": "A tribute to beautiful gardens everywhere. Celebrating the abundance of life and colour and natural art.",
        "albumInformation": "Composed, recorded and performed by Dino Pacifici. Album cover: Dino Pacifici. Released September 1, 2020.",
        "albumCopyright": "2020",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "The-Ambient-Garden",
        "albumSortOrder": 3,
        "albumReleaseDate": "2020-09-01T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 100,
            "fK_AlbumId": 13,
            "trackNumber": 1,
            "trackTitle": "The Meandering",
            "trackMP3": "DinoPacifici-TheAmbientGarden-01-TheMeandering.mp3",
            "trackLength": "00:06:30",
            "trackDescription": null
          },
          {
            "pK_TrackId": 101,
            "fK_AlbumId": 13,
            "trackNumber": 2,
            "trackTitle": "The Grasslands",
            "trackMP3": "DinoPacifici-TheAmbientGarden-02-TheGrasslands.mp3",
            "trackLength": "00:07:32",
            "trackDescription": null
          },
          {
            "pK_TrackId": 102,
            "fK_AlbumId": 13,
            "trackNumber": 3,
            "trackTitle": "The Tree And The Woodpecker",
            "trackMP3": "DinoPacifici-TheAmbientGarden-03-TheTreeAndTheWoodpecker.mp3",
            "trackLength": "00:07:03",
            "trackDescription": null
          },
          {
            "pK_TrackId": 103,
            "fK_AlbumId": 13,
            "trackNumber": 4,
            "trackTitle": "The Dragonfly",
            "trackMP3": "DinoPacifici-TheAmbientGarden-04-TheDragonfly.mp3",
            "trackLength": "00:06:08",
            "trackDescription": null
          },
          {
            "pK_TrackId": 104,
            "fK_AlbumId": 13,
            "trackNumber": 5,
            "trackTitle": "The Storm",
            "trackMP3": "DinoPacifici-TheAmbientGarden-05-TheStorm.mp3",
            "trackLength": "00:06:09",
            "trackDescription": null
          },
          {
            "pK_TrackId": 105,
            "fK_AlbumId": 13,
            "trackNumber": 6,
            "trackTitle": "The Mourning Dove",
            "trackMP3": "DinoPacifici-TheAmbientGarden-06-TheMourningDove.mp3",
            "trackLength": "00:05:05",
            "trackDescription": null
          },
          {
            "pK_TrackId": 106,
            "fK_AlbumId": 13,
            "trackNumber": 7,
            "trackTitle": "The Desert Cactus",
            "trackMP3": "DinoPacifici-TheAmbientGarden-07-TheDesertCactus.mp3",
            "trackLength": "00:07:12",
            "trackDescription": null
          },
          {
            "pK_TrackId": 107,
            "fK_AlbumId": 13,
            "trackNumber": 8,
            "trackTitle": "The Hummingbird",
            "trackMP3": "DinoPacifici-TheAmbientGarden-08-TheHummingbird.mp3",
            "trackLength": "00:06:07",
            "trackDescription": null
          },
          {
            "pK_TrackId": 108,
            "fK_AlbumId": 13,
            "trackNumber": 9,
            "trackTitle": "Claire's Hideaway",
            "trackMP3": "DinoPacifici-TheAmbientGarden-09-Claire'sHideaway.mp3",
            "trackLength": "00:04:09",
            "trackDescription": null
          },
          {
            "pK_TrackId": 109,
            "fK_AlbumId": 13,
            "trackNumber": 10,
            "trackTitle": "The Sun Sets, The Garden Sleeps",
            "trackMP3": "DinoPacifici-TheAmbientGarden-10-TheSunSets,TheGardenSleeps.mp3",
            "trackLength": "00:06:20",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 15,
            "fK_AlbumId": 13,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/the-ambient-garden",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 12,
        "fK_ArtistId": 1,
        "albumTitle": "Ambient Particles",
        "albumImageCover": "Dino_Pacifici_Ambient_Particles_Front.jpg",
        "albumImageBack": null,
        "albumLength": "00:24:19",
        "albumStory": "A conglomeration of musical tidbits combining to form one cohesive piece. Parts of a whole. This approximately 24-minute piece is a pastiche of different styles brought together as one. It is a multi-layered journey and experiment in ambient forms.",
        "albumInformation": "I create my music with Logic Pro X and a UAD Apollo 8. Software; Kontakt 6, Waves Plugins. Instruments use are: Roland Jx10, Roland S760, Kurzweil K2000, Waldorf XT, Assorted acoustic and electric guitars, exotic percussion, djembes, rain sticks, buzz marimba, sarod, kora, mbira, wood flutes, as well as additional instruments.  Photo: by Dino Pacifici.  Released May 12, 2020.",
        "albumCopyright": "2020",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "Ambient-Particles",
        "albumSortOrder": 2,
        "albumReleaseDate": "2020-05-13T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 99,
            "fK_AlbumId": 12,
            "trackNumber": 1,
            "trackTitle": "Ambient Particles",
            "trackMP3": "DinoPacifici-AmbientParticles-01-AmbientParticles.mp3",
            "trackLength": "00:24:19",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 16,
            "fK_AlbumId": 12,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/track/ambient-particles",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 11,
        "fK_ArtistId": 1,
        "albumTitle": "Ambient Orphans",
        "albumImageCover": "Dino_Pacifici_Ambient_Orphans_Front.jpg",
        "albumImageBack": null,
        "albumLength": "01:15:07",
        "albumStory": null,
        "albumInformation": "Composed and performed by Dino Pacifici.\r\nCompiled by Julien J. Dumont Jr.\r\nArtwork and notes by Julien J. Dumont Jr.",
        "albumCopyright": "2020",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "Ambient-Orphans",
        "albumSortOrder": 1,
        "albumReleaseDate": "2020-08-22T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 90,
            "fK_AlbumId": 11,
            "trackNumber": 1,
            "trackTitle": "Orphans Arrival",
            "trackMP3": "DinoPacifici-AmbientOrphans-01-OrphansArrival.mp3",
            "trackLength": "00:00:38",
            "trackDescription": null
          },
          {
            "pK_TrackId": 91,
            "fK_AlbumId": 11,
            "trackNumber": 2,
            "trackTitle": "Chronos",
            "trackMP3": "DinoPacifici-AmbientOrphans-02-Chronos.mp3",
            "trackLength": "00:09:15",
            "trackDescription": null
          },
          {
            "pK_TrackId": 92,
            "fK_AlbumId": 11,
            "trackNumber": 3,
            "trackTitle": "Cloud's Drift",
            "trackMP3": "DinoPacifici-AmbientOrphans-03-Cloud'sDrift.mp3",
            "trackLength": "00:17:35",
            "trackDescription": null
          },
          {
            "pK_TrackId": 93,
            "fK_AlbumId": 11,
            "trackNumber": 4,
            "trackTitle": "Water Spirit",
            "trackMP3": "DinoPacifici-AmbientOrphans-04-WaterSpirit.mp3",
            "trackLength": "00:08:01",
            "trackDescription": null
          },
          {
            "pK_TrackId": 94,
            "fK_AlbumId": 11,
            "trackNumber": 5,
            "trackTitle": "Hello Flow",
            "trackMP3": "DinoPacifici-AmbientOrphans-05-HelloFlow.mp3",
            "trackLength": "00:03:51",
            "trackDescription": null
          },
          {
            "pK_TrackId": 95,
            "fK_AlbumId": 11,
            "trackNumber": 6,
            "trackTitle": "Waterdome",
            "trackMP3": "DinoPacifici-AmbientOrphans-06-Waterdome.mp3",
            "trackLength": "00:14:24",
            "trackDescription": null
          },
          {
            "pK_TrackId": 96,
            "fK_AlbumId": 11,
            "trackNumber": 7,
            "trackTitle": "Plenitude Of Solitude",
            "trackMP3": "DinoPacifici-AmbientOrphans-07-PlenitudeOfSolitude.mp3",
            "trackLength": "00:14:42",
            "trackDescription": null
          },
          {
            "pK_TrackId": 97,
            "fK_AlbumId": 11,
            "trackNumber": 8,
            "trackTitle": "Desert Moon",
            "trackMP3": "DinoPacifici-AmbientOrphans-08-DesertMoon.mp3",
            "trackLength": "00:06:19",
            "trackDescription": null
          },
          {
            "pK_TrackId": 98,
            "fK_AlbumId": 11,
            "trackNumber": 9,
            "trackTitle": "Orphans Departure",
            "trackMP3": "DinoPacifici-AmbientOrphans-09-OrphansDeparture.mp3",
            "trackLength": "00:00:18",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 18,
            "fK_AlbumId": 11,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/ambient-orphans",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 10,
        "fK_ArtistId": 1,
        "albumTitle": "A Collection Of Shadows",
        "albumImageCover": "Dino_Pacifici_A_Collection_Of_Shadows_Front.jpg",
        "albumImageBack": null,
        "albumLength": "00:49:42",
        "albumStory": null,
        "albumInformation": "Photo: Cartagena Sunset ©Dino Pacifici 2020. Released May 11, 2020.",
        "albumCopyright": "2020",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "A-Collection-Of-Shadows",
        "albumSortOrder": 0,
        "albumReleaseDate": "2020-05-11T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 86,
            "fK_AlbumId": 10,
            "trackNumber": 1,
            "trackTitle": "Shadow One",
            "trackMP3": "DinoPacifici-ACollectionOfShadows-01-ShadowOne.mp3",
            "trackLength": "00:15:09",
            "trackDescription": null
          },
          {
            "pK_TrackId": 87,
            "fK_AlbumId": 10,
            "trackNumber": 2,
            "trackTitle": "Shadow Two",
            "trackMP3": "DinoPacifici-ACollectionOfShadows-02-ShadowTwo.mp3",
            "trackLength": "00:15:08",
            "trackDescription": null
          },
          {
            "pK_TrackId": 88,
            "fK_AlbumId": 10,
            "trackNumber": 3,
            "trackTitle": "Shadow Three",
            "trackMP3": "DinoPacifici-ACollectionOfShadows-03-ShadowThree.mp3",
            "trackLength": "00:10:44",
            "trackDescription": null
          },
          {
            "pK_TrackId": 89,
            "fK_AlbumId": 10,
            "trackNumber": 4,
            "trackTitle": "Shadow Four",
            "trackMP3": "DinoPacifici-ACollectionOfShadows-04-ShadowFour.mp3",
            "trackLength": "00:08:40",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 17,
            "fK_AlbumId": 10,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/a-collection-of-shadows",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 9,
        "fK_ArtistId": 1,
        "albumTitle": "The Float Zone",
        "albumImageCover": "Dino_Pacifici_The_Float_Zone_Front.jpg",
        "albumImageBack": null,
        "albumLength": "00:57:56",
        "albumStory": null,
        "albumInformation": "Composed, recorded and performed by, Dino Pacifici",
        "albumCopyright": "2004",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "The-Float-Zone",
        "albumSortOrder": 0,
        "albumReleaseDate": "2004-01-01T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 79,
            "fK_AlbumId": 9,
            "trackNumber": 1,
            "trackTitle": "The Currents Of Space Pt. 1",
            "trackMP3": "DinoPacifici-TheFloatZone-01-TheCurrentsOfSpacePt.1.mp3",
            "trackLength": "00:12:30",
            "trackDescription": null
          },
          {
            "pK_TrackId": 80,
            "fK_AlbumId": 9,
            "trackNumber": 2,
            "trackTitle": "When It Came",
            "trackMP3": "DinoPacifici-TheFloatZone-02-WhenItCame.mp3",
            "trackLength": "00:12:33",
            "trackDescription": null
          },
          {
            "pK_TrackId": 81,
            "fK_AlbumId": 9,
            "trackNumber": 3,
            "trackTitle": "Spectre",
            "trackMP3": "DinoPacifici-TheFloatZone-03-Spectre.mp3",
            "trackLength": "00:08:08",
            "trackDescription": null
          },
          {
            "pK_TrackId": 82,
            "fK_AlbumId": 9,
            "trackNumber": 4,
            "trackTitle": "Undercurrents",
            "trackMP3": "DinoPacifici-TheFloatZone-04-Undercurrents.mp3",
            "trackLength": "00:10:46",
            "trackDescription": null
          },
          {
            "pK_TrackId": 83,
            "fK_AlbumId": 9,
            "trackNumber": 5,
            "trackTitle": "The Float Zone",
            "trackMP3": "DinoPacifici-TheFloatZone-05-TheFloatZone.mp3",
            "trackLength": "00:08:31",
            "trackDescription": null
          },
          {
            "pK_TrackId": 84,
            "fK_AlbumId": 9,
            "trackNumber": 6,
            "trackTitle": "Epilogue",
            "trackMP3": "DinoPacifici-TheFloatZone-06-Epilogue.mp3",
            "trackLength": "00:04:44",
            "trackDescription": null
          },
          {
            "pK_TrackId": 85,
            "fK_AlbumId": 9,
            "trackNumber": 7,
            "trackTitle": "Outro",
            "trackMP3": "DinoPacifici-TheFloatZone-07-Outro.mp3",
            "trackLength": "00:00:42",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 19,
            "fK_AlbumId": 9,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/the-float-zone",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 8,
        "fK_ArtistId": 1,
        "albumTitle": "The Blue Velvet Lounge",
        "albumImageCover": "Dino_Pacifici_The_Blue_Velvet_Lounge_Front.jpg",
        "albumImageBack": null,
        "albumLength": "01:01:13",
        "albumStory": "Chill-out, ambient jazz. Sun and beach music:)",
        "albumInformation": "Composed, performed and recorded by: Dino Pacifici",
        "albumCopyright": "2002",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Chill-Out, Ambient, Jazz",
        "albumFriendlyUrl": "The-Blue-Velvet-Lounge",
        "albumSortOrder": 0,
        "albumReleaseDate": "2002-01-01T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 68,
            "fK_AlbumId": 8,
            "trackNumber": 1,
            "trackTitle": "Mirage",
            "trackMP3": "DinoPacifici-TheBlueVelvetLounge-01-Mirage.mp3",
            "trackLength": "00:06:38",
            "trackDescription": null
          },
          {
            "pK_TrackId": 69,
            "fK_AlbumId": 8,
            "trackNumber": 2,
            "trackTitle": "Itz About",
            "trackMP3": "DinoPacifici-TheBlueVelvetLounge-02-ItzAbout.mp3",
            "trackLength": "00:06:40",
            "trackDescription": null
          },
          {
            "pK_TrackId": 70,
            "fK_AlbumId": 8,
            "trackNumber": 3,
            "trackTitle": "Voices In My Head",
            "trackMP3": "DinoPacifici-TheBlueVelvetLounge-03-VoicesInMyHead.mp3",
            "trackLength": "00:04:58",
            "trackDescription": null
          },
          {
            "pK_TrackId": 71,
            "fK_AlbumId": 8,
            "trackNumber": 4,
            "trackTitle": "Night",
            "trackMP3": "DinoPacifici-TheBlueVelvetLounge-04-Nights.mp3",
            "trackLength": "00:06:05",
            "trackDescription": null
          },
          {
            "pK_TrackId": 72,
            "fK_AlbumId": 8,
            "trackNumber": 5,
            "trackTitle": "Warmfront",
            "trackMP3": "DinoPacifici-TheBlueVelvetLounge-05-Warmfront.mp3",
            "trackLength": "00:06:18",
            "trackDescription": null
          },
          {
            "pK_TrackId": 73,
            "fK_AlbumId": 8,
            "trackNumber": 6,
            "trackTitle": "Dreams in Green",
            "trackMP3": "DinoPacifici-TheBlueVelvetLounge-06-DreamsInGreen.mp3",
            "trackLength": "00:07:25",
            "trackDescription": null
          },
          {
            "pK_TrackId": 74,
            "fK_AlbumId": 8,
            "trackNumber": 7,
            "trackTitle": "Bossa On The Breeze",
            "trackMP3": "DinoPacifici-TheBlueVelvetLounge-07-BossaOnTheBreeze.mp3",
            "trackLength": "00:05:26",
            "trackDescription": null
          },
          {
            "pK_TrackId": 75,
            "fK_AlbumId": 8,
            "trackNumber": 8,
            "trackTitle": "The Blue Velvet Lounge",
            "trackMP3": "DinoPacifici-TheBlueVelvetLounge-08-TheBlueVelvetLounge.mp3",
            "trackLength": "00:04:34",
            "trackDescription": null
          },
          {
            "pK_TrackId": 76,
            "fK_AlbumId": 8,
            "trackNumber": 9,
            "trackTitle": "Why?",
            "trackMP3": "DinoPacifici-TheBlueVelvetLounge-09-Why_.mp3",
            "trackLength": "00:04:14",
            "trackDescription": null
          },
          {
            "pK_TrackId": 77,
            "fK_AlbumId": 8,
            "trackNumber": 10,
            "trackTitle": "Transmitting Data",
            "trackMP3": "DinoPacifici-TheBlueVelvetLounge-10-TransmittingData.mp3",
            "trackLength": "00:04:20",
            "trackDescription": null
          },
          {
            "pK_TrackId": 78,
            "fK_AlbumId": 8,
            "trackNumber": 11,
            "trackTitle": "East Of The West",
            "trackMP3": "DinoPacifici-TheBlueVelvetLounge-11-EastOfTheWest.mp3",
            "trackLength": "00:04:34",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 20,
            "fK_AlbumId": 8,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/the-blue-velvet-lounge",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 7,
        "fK_ArtistId": 1,
        "albumTitle": "Hallowed Ground",
        "albumImageCover": "Dino_Pacifici_Hallowed_Ground_Front.jpg",
        "albumImageBack": null,
        "albumLength": "01:07:27",
        "albumStory": null,
        "albumInformation": "Composed, recorded and performed by: Dino Pacifici",
        "albumCopyright": "1999",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "Hallowed-Ground",
        "albumSortOrder": 0,
        "albumReleaseDate": "1999-01-01T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 62,
            "fK_AlbumId": 7,
            "trackNumber": 1,
            "trackTitle": "Solace",
            "trackMP3": "DinoPacifici-HallowedGround-01-Solace.mp3",
            "trackLength": "00:22:45",
            "trackDescription": null
          },
          {
            "pK_TrackId": 63,
            "fK_AlbumId": 7,
            "trackNumber": 2,
            "trackTitle": "Timeshift",
            "trackMP3": "DinoPacifici-HallowedGround-02-Timeshift.mp3",
            "trackLength": "00:17:11",
            "trackDescription": null
          },
          {
            "pK_TrackId": 64,
            "fK_AlbumId": 7,
            "trackNumber": 3,
            "trackTitle": "Hallowed Ground",
            "trackMP3": "DinoPacifici-HallowedGround-03-HallowedGround.mp3",
            "trackLength": "00:08:42",
            "trackDescription": null
          },
          {
            "pK_TrackId": 65,
            "fK_AlbumId": 7,
            "trackNumber": 4,
            "trackTitle": "Warp",
            "trackMP3": "DinoPacifici-HallowedGround-04-Warp.mp3",
            "trackLength": "00:06:21",
            "trackDescription": null
          },
          {
            "pK_TrackId": 66,
            "fK_AlbumId": 7,
            "trackNumber": 5,
            "trackTitle": "The Ice Fields Of Neptune",
            "trackMP3": "DinoPacifici-HallowedGround-05-TheIceFieldsOfNeptune.mp3",
            "trackLength": "00:05:05",
            "trackDescription": null
          },
          {
            "pK_TrackId": 67,
            "fK_AlbumId": 7,
            "trackNumber": 6,
            "trackTitle": "Cave Dweller",
            "trackMP3": "DinoPacifici-HallowedGround-06-CaveDweller.mp3",
            "trackLength": "00:07:20",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 21,
            "fK_AlbumId": 7,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/hallowed-ground",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 6,
        "fK_ArtistId": 1,
        "albumTitle": "Acquiescent Resonance",
        "albumImageCover": "Dino_Pacifici_Acquiescent_Resonance_Front.jpg",
        "albumImageBack": null,
        "albumLength": "01:15:34",
        "albumStory": "From the Archives, this is my album of Ibiza style chill-out music. Beats and grooves!",
        "albumInformation": "Composed, recorded, mixed and performed by Dino Pacifici.",
        "albumCopyright": "1998",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Chill-Out, Ambient, Jazz",
        "albumFriendlyUrl": "Acquiescent-Resonance",
        "albumSortOrder": 0,
        "albumReleaseDate": "1998-07-01T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 50,
            "fK_AlbumId": 6,
            "trackNumber": 1,
            "trackTitle": "Dreams In Green",
            "trackMP3": "DinoPacifici-AcquiescentResonance-01-DreamsInGreen.mp3",
            "trackLength": "00:07:26",
            "trackDescription": null
          },
          {
            "pK_TrackId": 51,
            "fK_AlbumId": 6,
            "trackNumber": 2,
            "trackTitle": "It's Gotta Have Soul",
            "trackMP3": "DinoPacifici-AcquiescentResonance-02-It'sGottaHaveSoul.mp3",
            "trackLength": "00:05:24",
            "trackDescription": null
          },
          {
            "pK_TrackId": 52,
            "fK_AlbumId": 6,
            "trackNumber": 3,
            "trackTitle": "Itzabout",
            "trackMP3": "DinoPacifici-AcquiescentResonance-03-Itzabout.mp3",
            "trackLength": "00:06:44",
            "trackDescription": null
          },
          {
            "pK_TrackId": 53,
            "fK_AlbumId": 6,
            "trackNumber": 4,
            "trackTitle": "Night",
            "trackMP3": "DinoPacifici-AcquiescentResonance-04-Night.mp3",
            "trackLength": "00:06:09",
            "trackDescription": null
          },
          {
            "pK_TrackId": 54,
            "fK_AlbumId": 6,
            "trackNumber": 5,
            "trackTitle": "Acquiescent Resonance",
            "trackMP3": "DinoPacifici-AcquiescentResonance-05-AcquiescentResonance.mp3",
            "trackLength": "00:07:30",
            "trackDescription": null
          },
          {
            "pK_TrackId": 55,
            "fK_AlbumId": 6,
            "trackNumber": 6,
            "trackTitle": "Weird Science",
            "trackMP3": "DinoPacifici-AcquiescentResonance-06-WeirdScience.mp3",
            "trackLength": "00:07:33",
            "trackDescription": null
          },
          {
            "pK_TrackId": 56,
            "fK_AlbumId": 6,
            "trackNumber": 7,
            "trackTitle": "Shadow Lands",
            "trackMP3": "DinoPacifici-AcquiescentResonance-07-ShadowLands.mp3",
            "trackLength": "00:05:53",
            "trackDescription": null
          },
          {
            "pK_TrackId": 57,
            "fK_AlbumId": 6,
            "trackNumber": 8,
            "trackTitle": "Distand Hills",
            "trackMP3": "DinoPacifici-AcquiescentResonance-08-DistantHills.mp3",
            "trackLength": "00:05:08",
            "trackDescription": null
          },
          {
            "pK_TrackId": 58,
            "fK_AlbumId": 6,
            "trackNumber": 9,
            "trackTitle": "The Awakening",
            "trackMP3": "DinoPacifici-AcquiescentResonance-09-TheAwakening.mp3",
            "trackLength": "00:05:40",
            "trackDescription": null
          },
          {
            "pK_TrackId": 59,
            "fK_AlbumId": 6,
            "trackNumber": 10,
            "trackTitle": "See Beyond",
            "trackMP3": "DinoPacifici-AcquiescentResonance-10-SeeBeyond.mp3",
            "trackLength": "00:04:23",
            "trackDescription": null
          },
          {
            "pK_TrackId": 60,
            "fK_AlbumId": 6,
            "trackNumber": 11,
            "trackTitle": "Perc-U-Later",
            "trackMP3": "DinoPacifici-AcquiescentResonance-11-Perc-U-Later.mp3",
            "trackLength": "00:07:46",
            "trackDescription": null
          },
          {
            "pK_TrackId": 61,
            "fK_AlbumId": 6,
            "trackNumber": 12,
            "trackTitle": "Windsong",
            "trackMP3": "DinoPacifici-AcquiescentResonance-12-Windsong.mp3",
            "trackLength": "00:05:50",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 22,
            "fK_AlbumId": 6,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/acquiescent-resonance",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 24,
        "fK_ArtistId": 1,
        "albumTitle": "Christmas New Age",
        "albumImageCover": "Dino_Pacifici_Christmas_New_Age_Front.jpg",
        "albumImageBack": null,
        "albumLength": "01:04:02",
        "albumStory": null,
        "albumInformation": null,
        "albumCopyright": "1997",
        "albumCopyrightDescription": "Dance Plant/CMC Records",
        "albumGenres": "Holiday, New Age",
        "albumFriendlyUrl": "Christmas-New-Age",
        "albumSortOrder": 1,
        "albumReleaseDate": "1997-07-29T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 182,
            "fK_AlbumId": 24,
            "trackNumber": 1,
            "trackTitle": "Oh Christmas Tree",
            "trackMP3": "DinoPacifici-ChristmasNewAge-01-OhChristmasTree.mp3",
            "trackLength": "00:06:29",
            "trackDescription": null
          },
          {
            "pK_TrackId": 183,
            "fK_AlbumId": 24,
            "trackNumber": 2,
            "trackTitle": "Let It Snow",
            "trackMP3": "DinoPacifici-ChristmasNewAge-02-LetItSnow.mp3",
            "trackLength": "00:06:30",
            "trackDescription": null
          },
          {
            "pK_TrackId": 184,
            "fK_AlbumId": 24,
            "trackNumber": 3,
            "trackTitle": "God Rest Ye Merry Gentlemen",
            "trackMP3": "DinoPacifici-ChristmasNewAge-03-GodRestYeMerryGentlemen.mp3",
            "trackLength": "00:06:15",
            "trackDescription": null
          },
          {
            "pK_TrackId": 185,
            "fK_AlbumId": 24,
            "trackNumber": 4,
            "trackTitle": "We Wish You A Merry Christmas",
            "trackMP3": "DinoPacifici-ChristmasNewAge-04-WeWishYouAMerryChristmas.mp3",
            "trackLength": "00:06:08",
            "trackDescription": null
          },
          {
            "pK_TrackId": 186,
            "fK_AlbumId": 24,
            "trackNumber": 5,
            "trackTitle": "Silent Night",
            "trackMP3": "DinoPacifici-ChristmasNewAge-05-SilentNight.mp3",
            "trackLength": "00:06:45",
            "trackDescription": null
          },
          {
            "pK_TrackId": 187,
            "fK_AlbumId": 24,
            "trackNumber": 6,
            "trackTitle": "It Came Upon A Midnight Clear",
            "trackMP3": "DinoPacifici-ChristmasNewAge-06-ItCameUponAMidnightClear.mp3",
            "trackLength": "00:06:58",
            "trackDescription": null
          },
          {
            "pK_TrackId": 188,
            "fK_AlbumId": 24,
            "trackNumber": 7,
            "trackTitle": "Star Light, Star Bright",
            "trackMP3": "DinoPacifici-ChristmasNewAge-07-StarLight,StarBright.mp3",
            "trackLength": "00:05:03",
            "trackDescription": null
          },
          {
            "pK_TrackId": 189,
            "fK_AlbumId": 24,
            "trackNumber": 8,
            "trackTitle": "Happy Christmas",
            "trackMP3": "DinoPacifici-ChristmasNewAge-08-HappyChristmas.mp3",
            "trackLength": "00:06:31",
            "trackDescription": null
          },
          {
            "pK_TrackId": 190,
            "fK_AlbumId": 24,
            "trackNumber": 9,
            "trackTitle": "The Heaven's Angels",
            "trackMP3": "DinoPacifici-ChristmasNewAge-09-TheHeaven'sAngels.mp3",
            "trackLength": "00:06:59",
            "trackDescription": null
          },
          {
            "pK_TrackId": 191,
            "fK_AlbumId": 24,
            "trackNumber": 10,
            "trackTitle": "The Good King Wenceslas",
            "trackMP3": "DinoPacifici-ChristmasNewAge-10-TheGoodKingWenceslas.mp3",
            "trackLength": "00:06:21",
            "trackDescription": null
          }
        ],
        "buyAts": [],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 5,
        "fK_ArtistId": 1,
        "albumTitle": "The Journey",
        "albumImageCover": "Dino_Pacifici_The_Journey_Front.jpg",
        "albumImageBack": null,
        "albumLength": "01:08:02",
        "albumStory": "Recorded in 1997 at Scorpio Rising Music, The Journey was chosen as a finalist in the Ambient category, New Age Voice magazine.It gives me pleasure to re-release this music for you.",
        "albumInformation": "Composed, recorded, mixed and mastered by Dino Pacifici.\r\nAll instruments and programming by: Dino Pacifici",
        "albumCopyright": "1997",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "The-Journey",
        "albumSortOrder": 0,
        "albumReleaseDate": "1997-07-01T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 41,
            "fK_AlbumId": 5,
            "trackNumber": 1,
            "trackTitle": "The Journey",
            "trackMP3": "DinoPacifici-TheJourney-01-TheJourney.mp3",
            "trackLength": "00:07:34",
            "trackDescription": null
          },
          {
            "pK_TrackId": 42,
            "fK_AlbumId": 5,
            "trackNumber": 2,
            "trackTitle": "Earth Song Trilogy",
            "trackMP3": "DinoPacifici-TheJourney-02-EarthSongTrilogy.mp3",
            "trackLength": "00:10:48",
            "trackDescription": null
          },
          {
            "pK_TrackId": 43,
            "fK_AlbumId": 5,
            "trackNumber": 3,
            "trackTitle": "Cirrostratus",
            "trackMP3": "DinoPacifici-TheJourney-03-Cirrostratus.mp3",
            "trackLength": "00:05:38",
            "trackDescription": null
          },
          {
            "pK_TrackId": 44,
            "fK_AlbumId": 5,
            "trackNumber": 4,
            "trackTitle": "Cascades (Movements I & II)",
            "trackMP3": "DinoPacifici-TheJourney-04-Cascades(MovementsI&II).mp3",
            "trackLength": "00:07:33",
            "trackDescription": null
          },
          {
            "pK_TrackId": 45,
            "fK_AlbumId": 5,
            "trackNumber": 5,
            "trackTitle": "Revirie",
            "trackMP3": "DinoPacifici-TheJourney-05-Reverie.mp3",
            "trackLength": "00:07:05",
            "trackDescription": null
          },
          {
            "pK_TrackId": 46,
            "fK_AlbumId": 5,
            "trackNumber": 6,
            "trackTitle": "Voices In The Mist",
            "trackMP3": "DinoPacifici-TheJourney-06-VoicesInTheMist.mp3",
            "trackLength": "00:06:47",
            "trackDescription": null
          },
          {
            "pK_TrackId": 47,
            "fK_AlbumId": 5,
            "trackNumber": 7,
            "trackTitle": "Submergence",
            "trackMP3": "DinoPacifici-TheJourney-07-Submergence.mp3",
            "trackLength": "00:07:02",
            "trackDescription": null
          },
          {
            "pK_TrackId": 48,
            "fK_AlbumId": 5,
            "trackNumber": 8,
            "trackTitle": "An Afternoon In My Neighborhood",
            "trackMP3": "DinoPacifici-TheJourney-08-AnAfternoonInMyNeighbourhood.mp3",
            "trackLength": "00:04:21",
            "trackDescription": null
          },
          {
            "pK_TrackId": 49,
            "fK_AlbumId": 5,
            "trackNumber": 9,
            "trackTitle": "Rainforest Rhapsody",
            "trackMP3": "DinoPacifici-TheJourney-09-RainforestRhapsody.mp3",
            "trackLength": "00:11:02",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 23,
            "fK_AlbumId": 5,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/the-journey",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 4,
        "fK_ArtistId": 1,
        "albumTitle": "Urban Oasis",
        "albumImageCover": "Dino_Pacifici_Urban_Oasis_Front.jpg",
        "albumImageBack": null,
        "albumLength": "00:58:51",
        "albumStory": "An archive release from 1996. This is my foray into west coast style smooth jazz. Main instruments taking lead are guitar and tenor sax.",
        "albumInformation": "Dino Pacifici - composer, recording, mixing, guitar.\r\nRichard Trepanier - Tenor and soprano saxes.",
        "albumCopyright": "1996",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Smooth Jazz",
        "albumFriendlyUrl": "Urban-Oasis",
        "albumSortOrder": 0,
        "albumReleaseDate": "1996-07-01T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 30,
            "fK_AlbumId": 4,
            "trackNumber": 1,
            "trackTitle": "Santa Ana Winds",
            "trackMP3": "DinoPacifici-UrbanOasis-01-SantaAnaWinds.mp3",
            "trackLength": "00:04:59",
            "trackDescription": null
          },
          {
            "pK_TrackId": 31,
            "fK_AlbumId": 4,
            "trackNumber": 2,
            "trackTitle": "Cool Blue",
            "trackMP3": "DinoPacifici-UrbanOasis-02-CoolBlue.mp3",
            "trackLength": "00:05:47",
            "trackDescription": null
          },
          {
            "pK_TrackId": 32,
            "fK_AlbumId": 4,
            "trackNumber": 3,
            "trackTitle": "Slow Boil",
            "trackMP3": "DinoPacifici-UrbanOasis-03-SlowBoil.mp3",
            "trackLength": "00:04:58",
            "trackDescription": null
          },
          {
            "pK_TrackId": 33,
            "fK_AlbumId": 4,
            "trackNumber": 4,
            "trackTitle": "Urban Oasis",
            "trackMP3": "DinoPacifici-UrbanOasis-04-UrbanOasis.mp3",
            "trackLength": "00:03:17",
            "trackDescription": null
          },
          {
            "pK_TrackId": 34,
            "fK_AlbumId": 4,
            "trackNumber": 5,
            "trackTitle": "Iridescence",
            "trackMP3": "DinoPacifici-UrbanOasis-05-Iridescence.mp3",
            "trackLength": "00:06:03",
            "trackDescription": null
          },
          {
            "pK_TrackId": 35,
            "fK_AlbumId": 4,
            "trackNumber": 6,
            "trackTitle": "Long Summer Nights",
            "trackMP3": "DinoPacifici-UrbanOasis-06-LongSummerNights.mp3",
            "trackLength": "00:06:44",
            "trackDescription": null
          },
          {
            "pK_TrackId": 36,
            "fK_AlbumId": 4,
            "trackNumber": 7,
            "trackTitle": "On The Strip",
            "trackMP3": "DinoPacifici-UrbanOasis-07-OnTheStrip.mp3",
            "trackLength": "00:04:50",
            "trackDescription": null
          },
          {
            "pK_TrackId": 37,
            "fK_AlbumId": 4,
            "trackNumber": 8,
            "trackTitle": "Sundance",
            "trackMP3": "DinoPacifici-UrbanOasis-08-Sundance.mp3",
            "trackLength": "00:05:12",
            "trackDescription": null
          },
          {
            "pK_TrackId": 38,
            "fK_AlbumId": 4,
            "trackNumber": 9,
            "trackTitle": "Colours",
            "trackMP3": "DinoPacifici-UrbanOasis-09-Colours.mp3",
            "trackLength": "00:05:14",
            "trackDescription": null
          },
          {
            "pK_TrackId": 39,
            "fK_AlbumId": 4,
            "trackNumber": 10,
            "trackTitle": "Floating On The Airwaves",
            "trackMP3": "DinoPacifici-UrbanOasis-10-FloatingOnTheAirwaves.mp3",
            "trackLength": "00:06:03",
            "trackDescription": null
          },
          {
            "pK_TrackId": 40,
            "fK_AlbumId": 4,
            "trackNumber": 11,
            "trackTitle": "The Look Within",
            "trackMP3": "DinoPacifici-UrbanOasis-11-TheLookWithin.mp3",
            "trackLength": "00:05:38",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 24,
            "fK_AlbumId": 4,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/urban-oasis",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 3,
        "fK_ArtistId": 1,
        "albumTitle": "Reflections, Long Ago And Far Away",
        "albumImageCover": "Dino_Pacifici_Reflections_Front.jpg",
        "albumImageBack": null,
        "albumLength": "00:51:55",
        "albumStory": "Relaxation, Peace, serenity and meditation.",
        "albumInformation": "Composed, performed, arranged and recorded by Dino Pacifici ",
        "albumCopyright": "1994",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Ambient",
        "albumFriendlyUrl": "Reflections-Long-Ago-And-Far-Away",
        "albumSortOrder": 1,
        "albumReleaseDate": "1994-01-01T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 24,
            "fK_AlbumId": 3,
            "trackNumber": 1,
            "trackTitle": "Alone In My Thoughts",
            "trackMP3": "DinoPacifici-Reflections_LongAgoAndFarAway-01-AloneInMyThoughts.mp3",
            "trackLength": "00:08:34",
            "trackDescription": null
          },
          {
            "pK_TrackId": 25,
            "fK_AlbumId": 3,
            "trackNumber": 2,
            "trackTitle": "Vita Nuova",
            "trackMP3": "DinoPacifici-Reflections_LongAgoAndFarAway-02-VitaNuova.mp3",
            "trackLength": "00:09:31",
            "trackDescription": null
          },
          {
            "pK_TrackId": 26,
            "fK_AlbumId": 3,
            "trackNumber": 3,
            "trackTitle": "Aloft In Blue",
            "trackMP3": "DinoPacifici-Reflections_LongAgoAndFarAway-03-AloftInBlue.mp3",
            "trackLength": "00:09:30",
            "trackDescription": null
          },
          {
            "pK_TrackId": 27,
            "fK_AlbumId": 3,
            "trackNumber": 4,
            "trackTitle": "Beyond The Horizon",
            "trackMP3": "DinoPacifici-Reflections_LongAgoAndFarAway-04-BeyondTheHorizon.mp3",
            "trackLength": "00:06:34",
            "trackDescription": null
          },
          {
            "pK_TrackId": 28,
            "fK_AlbumId": 3,
            "trackNumber": 5,
            "trackTitle": "Reflections, Long Ago And Far Away",
            "trackMP3": "DinoPacifici-Reflections_LongAgoAndFarAway-05-Reflections(LongAgoAndFarAway).mp3",
            "trackLength": "00:03:59",
            "trackDescription": null
          },
          {
            "pK_TrackId": 29,
            "fK_AlbumId": 3,
            "trackNumber": 6,
            "trackTitle": "Infinity",
            "trackMP3": "DinoPacifici-Reflections_LongAgoAndFarAway-06-Infinity.mp3",
            "trackLength": "00:13:45",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 25,
            "fK_AlbumId": 3,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/reflections-long-ago-and-far-away",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 2,
        "fK_ArtistId": 1,
        "albumTitle": "Random Factors",
        "albumImageCover": "Dino_Pacifici_Random_Factors_Front.jpg",
        "albumImageBack": null,
        "albumLength": "01:13:37",
        "albumStory": "My first cd released in 1994 is a mix of different styles from Smooth jazz to ambient to experimental. At this time i was still searching for my voice.",
        "albumInformation": "Composed, performed and recorded by Dino Pacifici",
        "albumCopyright": "1994",
        "albumCopyrightDescription": "Scorpio Rising Music",
        "albumGenres": "Smooth Jazz, Ambient",
        "albumFriendlyUrl": "Random-Factors",
        "albumSortOrder": 0,
        "albumReleaseDate": "1994-01-01T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 11,
            "fK_AlbumId": 2,
            "trackNumber": 1,
            "trackTitle": "Midnight Sun",
            "trackMP3": "DinoPacifici-RandomFactors-01-MidnightSun.mp3",
            "trackLength": "00:05:33",
            "trackDescription": null
          },
          {
            "pK_TrackId": 12,
            "fK_AlbumId": 2,
            "trackNumber": 2,
            "trackTitle": "Northern Lights",
            "trackMP3": "DinoPacifici-RandomFactors-02-NorthernLights.mp3",
            "trackLength": "00:06:46",
            "trackDescription": null
          },
          {
            "pK_TrackId": 13,
            "fK_AlbumId": 2,
            "trackNumber": 3,
            "trackTitle": "Oasis",
            "trackMP3": "DinoPacifici-RandomFactors-03-Oasis.mp3",
            "trackLength": "00:05:41",
            "trackDescription": null
          },
          {
            "pK_TrackId": 14,
            "fK_AlbumId": 2,
            "trackNumber": 4,
            "trackTitle": "Southbound",
            "trackMP3": "DinoPacifici-RandomFactors-04-Southbound.mp3",
            "trackLength": "00:05:15",
            "trackDescription": null
          },
          {
            "pK_TrackId": 15,
            "fK_AlbumId": 2,
            "trackNumber": 5,
            "trackTitle": "Dreamscape",
            "trackMP3": "DinoPacifici-RandomFactors-05-Dreamscape.mp3",
            "trackLength": "00:05:49",
            "trackDescription": null
          },
          {
            "pK_TrackId": 16,
            "fK_AlbumId": 2,
            "trackNumber": 6,
            "trackTitle": "Mantra",
            "trackMP3": "DinoPacifici-RandomFactors-06-Mantra.mp3",
            "trackLength": "00:04:15",
            "trackDescription": null
          },
          {
            "pK_TrackId": 17,
            "fK_AlbumId": 2,
            "trackNumber": 7,
            "trackTitle": "Nocturnal Dance",
            "trackMP3": "DinoPacifici-RandomFactors-07-NocturnalDance.mp3",
            "trackLength": "00:00:58",
            "trackDescription": null
          },
          {
            "pK_TrackId": 18,
            "fK_AlbumId": 2,
            "trackNumber": 8,
            "trackTitle": "Odyssey",
            "trackMP3": "DinoPacifici-RandomFactors-08-Odyssey.mp3",
            "trackLength": "00:03:39",
            "trackDescription": null
          },
          {
            "pK_TrackId": 19,
            "fK_AlbumId": 2,
            "trackNumber": 9,
            "trackTitle": "A Walk Through Paris' Streets",
            "trackMP3": "DinoPacifici-RandomFactors-09-AWalkThroughParis'Streets.mp3",
            "trackLength": "00:03:49",
            "trackDescription": null
          },
          {
            "pK_TrackId": 20,
            "fK_AlbumId": 2,
            "trackNumber": 10,
            "trackTitle": "Alexander's Adventures",
            "trackMP3": "DinoPacifici-RandomFactors-10-Alexander'sAdventures.mp3",
            "trackLength": "00:07:48",
            "trackDescription": null
          },
          {
            "pK_TrackId": 21,
            "fK_AlbumId": 2,
            "trackNumber": 11,
            "trackTitle": "The Ice Fields Of Neptune",
            "trackMP3": "DinoPacifici-RandomFactors-11-TheIceFieldsOfNeptune.mp3",
            "trackLength": "00:05:04",
            "trackDescription": null
          },
          {
            "pK_TrackId": 22,
            "fK_AlbumId": 2,
            "trackNumber": 12,
            "trackTitle": "Anajym",
            "trackMP3": "DinoPacifici-RandomFactors-12-Anajym.mp3",
            "trackLength": "00:05:58",
            "trackDescription": null
          },
          {
            "pK_TrackId": 23,
            "fK_AlbumId": 2,
            "trackNumber": 13,
            "trackTitle": "Random Factors",
            "trackMP3": "DinoPacifici-RandomFactors-13-RandomFactors.mp3",
            "trackLength": "00:04:57",
            "trackDescription": null
          }
        ],
        "buyAts": [
          {
            "pK_BuyAtId": 26,
            "fK_AlbumId": 2,
            "linkSiteName": "BandCamp",
            "linkUrl": "https://dinopacifici.bandcamp.com/album/random-factors",
            "linkLabel": "BandCamp",
            "linkIcon": null,
            "linkOrder": 1,
            "linkShow": true
          }
        ],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 26,
        "fK_ArtistId": 1,
        "albumTitle": "L'Organe",
        "albumImageCover": "Dino_Pacifici_L'Organe_Front.jpg",
        "albumImageBack": null,
        "albumLength": "00:27:29",
        "albumStory": "This album is a comic book soundtrack",
        "albumInformation": null,
        "albumCopyright": "1988",
        "albumCopyrightDescription": "Les Publications GOGO GUY",
        "albumGenres": "Soundtrack",
        "albumFriendlyUrl": "LOrgane",
        "albumSortOrder": 1,
        "albumReleaseDate": "1988-01-01T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 199,
            "fK_AlbumId": 26,
            "trackNumber": 1,
            "trackTitle": "La Barbe",
            "trackMP3": "DinoPacifici-L'Organe-01-LaBarbe.mp3",
            "trackLength": "00:02:56",
            "trackDescription": null
          },
          {
            "pK_TrackId": 200,
            "fK_AlbumId": 26,
            "trackNumber": 2,
            "trackTitle": "Mac Ti-Nac",
            "trackMP3": "DinoPacifici-L'Organe-02-MacTi-Nac.mp3",
            "trackLength": "00:02:22",
            "trackDescription": null
          },
          {
            "pK_TrackId": 201,
            "fK_AlbumId": 26,
            "trackNumber": 3,
            "trackTitle": "Sur Le Balcon Avec Gogo Guy",
            "trackMP3": "DinoPacifici-L'Organe-03-SurLeBalconAvecGogoGuy.mp3",
            "trackLength": "00:03:53",
            "trackDescription": null
          },
          {
            "pK_TrackId": 202,
            "fK_AlbumId": 26,
            "trackNumber": 4,
            "trackTitle": "Le Cri D'Une Brebie (Cartoon)",
            "trackMP3": "DinoPacifici-L'Organe-04-LeCriD'UneBrebie(Cartoon).mp3",
            "trackLength": "00:03:02",
            "trackDescription": null
          },
          {
            "pK_TrackId": 203,
            "fK_AlbumId": 26,
            "trackNumber": 5,
            "trackTitle": "Marlene",
            "trackMP3": "DinoPacifici-L'Organe-05-Marlene.mp3",
            "trackLength": "00:03:39",
            "trackDescription": null
          },
          {
            "pK_TrackId": 204,
            "fK_AlbumId": 26,
            "trackNumber": 6,
            "trackTitle": "Le Trou Noir",
            "trackMP3": "DinoPacifici-L'Organe-06-LeTrouNoir.mp3",
            "trackLength": "00:02:43",
            "trackDescription": null
          },
          {
            "pK_TrackId": 205,
            "fK_AlbumId": 26,
            "trackNumber": 7,
            "trackTitle": "Le Saint Mene La Danse",
            "trackMP3": "DinoPacifici-L'Organe-07-LeSaintMeneLaDanse.mp3",
            "trackLength": "00:03:08",
            "trackDescription": null
          },
          {
            "pK_TrackId": 206,
            "fK_AlbumId": 26,
            "trackNumber": 8,
            "trackTitle": "Le Cahier Des Sports",
            "trackMP3": "DinoPacifici-L'Organe-08-LeCahierDesSports.mp3",
            "trackLength": "00:03:12",
            "trackDescription": null
          },
          {
            "pK_TrackId": 207,
            "fK_AlbumId": 26,
            "trackNumber": 9,
            "trackTitle": "Untitled",
            "trackMP3": "DinoPacifici-L'Organe-09-Untitled.mp3",
            "trackLength": "00:02:31",
            "trackDescription": null
          }
        ],
        "buyAts": [],
        "featuredAlbum": false,
        "showOnWebsite": true
      },
      {
        "pK_AlbumId": 1,
        "fK_ArtistId": 1,
        "albumTitle": "Become A Man",
        "albumImageCover": "Dino_Pacifici_Become_A_Man_Front.jpg",
        "albumImageBack": null,
        "albumLength": "00:41:12",
        "albumStory": null,
        "albumInformation": null,
        "albumCopyright": "1979",
        "albumCopyrightDescription": "NAB Artist Records",
        "albumGenres": "Rock",
        "albumFriendlyUrl": "Become-A-Man",
        "albumSortOrder": 0,
        "albumReleaseDate": "1979-01-01T00:00:00",
        "tracks": [
          {
            "pK_TrackId": 1,
            "fK_AlbumId": 1,
            "trackNumber": 1,
            "trackTitle": "Gone Are The Days",
            "trackMP3": "DinoPacifici-BecomeAMan-01-GoneAreTheDays.mp3",
            "trackLength": "00:03:12",
            "trackDescription": null
          },
          {
            "pK_TrackId": 2,
            "fK_AlbumId": 1,
            "trackNumber": 2,
            "trackTitle": "Jamaican Night",
            "trackMP3": "DinoPacifici-BecomeAMan-02-JamaicanNight.mp3",
            "trackLength": "00:05:23",
            "trackDescription": null
          },
          {
            "pK_TrackId": 3,
            "fK_AlbumId": 1,
            "trackNumber": 3,
            "trackTitle": "Become A Man",
            "trackMP3": "DinoPacifici-BecomeAMan-03-BecomeAMan.mp3",
            "trackLength": "00:03:56",
            "trackDescription": null
          },
          {
            "pK_TrackId": 4,
            "fK_AlbumId": 1,
            "trackNumber": 4,
            "trackTitle": "Seasons Of My Life",
            "trackMP3": "DinoPacifici-BecomeAMan-04-SeasonsOfMyLife.mp3",
            "trackLength": "00:03:34",
            "trackDescription": null
          },
          {
            "pK_TrackId": 5,
            "fK_AlbumId": 1,
            "trackNumber": 5,
            "trackTitle": "Sun Shining In My Window",
            "trackMP3": "DinoPacifici-BecomeAMan-05-SunShiningInMyWindow.mp3",
            "trackLength": "00:04:05",
            "trackDescription": null
          },
          {
            "pK_TrackId": 6,
            "fK_AlbumId": 1,
            "trackNumber": 6,
            "trackTitle": "Down Mexico Way",
            "trackMP3": "DinoPacifici-BecomeAMan-06-DownMexicoWay.mp3",
            "trackLength": "00:03:25",
            "trackDescription": null
          },
          {
            "pK_TrackId": 7,
            "fK_AlbumId": 1,
            "trackNumber": 7,
            "trackTitle": "Living Alone",
            "trackMP3": "DinoPacifici-BecomeAMan-07-LivingAlone.mp3",
            "trackLength": "00:03:05",
            "trackDescription": null
          },
          {
            "pK_TrackId": 8,
            "fK_AlbumId": 1,
            "trackNumber": 8,
            "trackTitle": "Whatever Happened",
            "trackMP3": "DinoPacifici-BecomeAMan-08-WhateverHappened.mp3",
            "trackLength": "00:04:37",
            "trackDescription": null
          },
          {
            "pK_TrackId": 9,
            "fK_AlbumId": 1,
            "trackNumber": 9,
            "trackTitle": "We Can Still Be friends",
            "trackMP3": "DinoPacifici-BecomeAMan-09-WeCanStillBeFriends.mp3",
            "trackLength": "00:03:13",
            "trackDescription": null
          },
          {
            "pK_TrackId": 10,
            "fK_AlbumId": 1,
            "trackNumber": 10,
            "trackTitle": "Interlude 1741",
            "trackMP3": "DinoPacifici-BecomeAMan-10-Interlude1741.mp3",
            "trackLength": "00:06:38",
            "trackDescription": null
          }
        ],
        "buyAts": [],
        "featuredAlbum": false,
        "showOnWebsite": true
      }
    ],
    "artistPhotos": [
      {
        "pK_PhotoId": 22,
        "fK_ArtistId": 1,
        "photoName": "DinoWithFender0518.jpg",
        "photoDescription": "Dino With His Fender Guitar",
        "photoStory": null,
        "photoDate": "2025-05-18T00:00:00",
        "photoSequence": 22,
        "photoShow": true
      },
      {
        "pK_PhotoId": 21,
        "fK_ArtistId": 1,
        "photoName": "DinoWayfarer0423.jpg",
        "photoDescription": "Dino Wearing Wayfarer T-Shirt",
        "photoStory": null,
        "photoDate": "2025-04-23T00:00:00",
        "photoSequence": 21,
        "photoShow": true
      },
      {
        "pK_PhotoId": 20,
        "fK_ArtistId": 1,
        "photoName": "DinoAtTheBoard0422.jpg",
        "photoDescription": "Dino At The Board",
        "photoStory": null,
        "photoDate": "2025-04-22T00:00:00",
        "photoSequence": 20,
        "photoShow": true
      },
      {
        "pK_PhotoId": 19,
        "fK_ArtistId": 1,
        "photoName": "DinoStudio0409.jpg",
        "photoDescription": "Dino In The Studio",
        "photoStory": null,
        "photoDate": "2025-04-09T00:00:00",
        "photoSequence": 19,
        "photoShow": true
      },
      {
        "pK_PhotoId": 18,
        "fK_ArtistId": 1,
        "photoName": "Dino_JJD_0925231321.jpg",
        "photoDescription": "Dino & Julien",
        "photoStory": "Dino & Julien in the studio working on the 'Enter The Shadows' track.",
        "photoDate": "2023-09-25T00:00:00",
        "photoSequence": 18,
        "photoShow": true
      },
      {
        "pK_PhotoId": 17,
        "fK_ArtistId": 1,
        "photoName": "IMG_1853.JPG",
        "photoDescription": "Dee With A Buddy",
        "photoStory": null,
        "photoDate": "2023-07-26T00:00:00",
        "photoSequence": 17,
        "photoShow": true
      },
      {
        "pK_PhotoId": 16,
        "fK_ArtistId": 1,
        "photoName": "IMG_3096.JPG",
        "photoDescription": "Dee 'The Thinker'",
        "photoStory": null,
        "photoDate": "2023-07-23T00:00:00",
        "photoSequence": 16,
        "photoShow": true
      },
      {
        "pK_PhotoId": 15,
        "fK_ArtistId": 1,
        "photoName": "IMG_2352.jpg",
        "photoDescription": "Studio",
        "photoStory": "This is some of the equipment in my studio.  I have used this gear to make many many many albums!",
        "photoDate": "2023-02-22T00:00:00",
        "photoSequence": 15,
        "photoShow": true
      },
      {
        "pK_PhotoId": 14,
        "fK_ArtistId": 1,
        "photoName": "Studio1.jpg",
        "photoDescription": "Studio",
        "photoStory": null,
        "photoDate": "2020-07-19T00:00:00",
        "photoSequence": 14,
        "photoShow": true
      },
      {
        "pK_PhotoId": 13,
        "fK_ArtistId": 1,
        "photoName": "NeonDee.jpg",
        "photoDescription": "Neon Dee",
        "photoStory": null,
        "photoDate": "2020-07-05T00:00:00",
        "photoSequence": 13,
        "photoShow": true
      },
      {
        "pK_PhotoId": 12,
        "fK_ArtistId": 1,
        "photoName": "IMG_0266.JPG",
        "photoDescription": "Photographer Dee",
        "photoStory": null,
        "photoDate": "2019-02-06T00:00:00",
        "photoSequence": 12,
        "photoShow": true
      },
      {
        "pK_PhotoId": 11,
        "fK_ArtistId": 1,
        "photoName": "Dee5x.jpg",
        "photoDescription": "Dee Hiking",
        "photoStory": null,
        "photoDate": "2018-09-30T00:00:00",
        "photoSequence": 11,
        "photoShow": true
      },
      {
        "pK_PhotoId": 10,
        "fK_ArtistId": 1,
        "photoName": "Dee1x.jpg",
        "photoDescription": "Deep Woods Dee",
        "photoStory": null,
        "photoDate": "2018-09-30T00:00:00",
        "photoSequence": 10,
        "photoShow": true
      },
      {
        "pK_PhotoId": 9,
        "fK_ArtistId": 1,
        "photoName": "IMG_1841.JPG",
        "photoDescription": "Dee Live",
        "photoStory": null,
        "photoDate": "2018-05-24T00:00:00",
        "photoSequence": 9,
        "photoShow": true
      },
      {
        "pK_PhotoId": 8,
        "fK_ArtistId": 1,
        "photoName": "IMG_2300.JPG",
        "photoDescription": "Dee Snowshoeing",
        "photoStory": null,
        "photoDate": "2018-02-13T00:00:00",
        "photoSequence": 8,
        "photoShow": true
      },
      {
        "pK_PhotoId": 7,
        "fK_ArtistId": 1,
        "photoName": "IMG_2256.JPG",
        "photoDescription": "Dee and Carly",
        "photoStory": null,
        "photoDate": "2018-01-18T00:00:00",
        "photoSequence": 7,
        "photoShow": true
      },
      {
        "pK_PhotoId": 6,
        "fK_ArtistId": 1,
        "photoName": "IMG_2154.JPG",
        "photoDescription": "Dee Skiing",
        "photoStory": null,
        "photoDate": "2018-01-11T00:00:00",
        "photoSequence": 6,
        "photoShow": true
      },
      {
        "pK_PhotoId": 5,
        "fK_ArtistId": 1,
        "photoName": "Dee_1.jpg",
        "photoDescription": "Dee Live",
        "photoStory": null,
        "photoDate": "2017-12-08T00:00:00",
        "photoSequence": 5,
        "photoShow": true
      },
      {
        "pK_PhotoId": 4,
        "fK_ArtistId": 1,
        "photoName": "Dee_And_Al.jpg",
        "photoDescription": "Dee and Al",
        "photoStory": null,
        "photoDate": "2016-02-20T00:00:00",
        "photoSequence": 4,
        "photoShow": true
      },
      {
        "pK_PhotoId": 3,
        "fK_ArtistId": 1,
        "photoName": "IMG_0149.JPG",
        "photoDescription": "Merry Christmas Dee",
        "photoStory": null,
        "photoDate": "2015-12-25T00:00:00",
        "photoSequence": 3,
        "photoShow": true
      },
      {
        "pK_PhotoId": 2,
        "fK_ArtistId": 1,
        "photoName": "IMG_0208.JPG",
        "photoDescription": "Studio",
        "photoStory": null,
        "photoDate": "2015-06-27T00:00:00",
        "photoSequence": 2,
        "photoShow": true
      },
      {
        "pK_PhotoId": 1,
        "fK_ArtistId": 1,
        "photoName": "Dee_2.jpg",
        "photoDescription": "Dee with guitar",
        "photoStory": null,
        "photoDate": "2012-10-27T00:00:00",
        "photoSequence": 1,
        "photoShow": true
      }
    ],
    "artistInstruments": [
      {
        "pK_InstrumentId": 26,
        "fK_ArtistId": 1,
        "instrumentName": "Moog0713.jpg",
        "instrumentDescription": "Moog",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 26,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 25,
        "fK_ArtistId": 1,
        "instrumentName": "StudioGear0202.jpg",
        "instrumentDescription": "Studio Gear",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 25,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 24,
        "fK_ArtistId": 1,
        "instrumentName": "Flutes.jpg",
        "instrumentDescription": "Various Flutes",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 24,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 23,
        "fK_ArtistId": 1,
        "instrumentName": "Urhu RainStickDidgerid.jpg",
        "instrumentDescription": "Urhu, Rain Stick and Didgeridoo (yidaki)",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 23,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 22,
        "fK_ArtistId": 1,
        "instrumentName": "StudioRig.jpg",
        "instrumentDescription": "My Studio rig",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 22,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 21,
        "fK_ArtistId": 1,
        "instrumentName": "UkranianBandurra.jpg",
        "instrumentDescription": "Ukranian Bandurra",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 21,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 20,
        "fK_ArtistId": 1,
        "instrumentName": "SopranoUdu.jpg",
        "instrumentDescription": "Soprano Udu",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 20,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 19,
        "fK_ArtistId": 1,
        "instrumentName": "Sarod.jpg",
        "instrumentDescription": "Sarod",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 19,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 18,
        "fK_ArtistId": 1,
        "instrumentName": "PolynesianAuglang.jpg",
        "instrumentDescription": "Polynesian Auglang",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 18,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 17,
        "fK_ArtistId": 1,
        "instrumentName": "SteinbergerAndVox.jpg",
        "instrumentDescription": "My Steinberger and Vox. My main guitar",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 17,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 16,
        "fK_ArtistId": 1,
        "instrumentName": "ListeningRig.jpg",
        "instrumentDescription": "My listening rig outside of the studio",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 16,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 15,
        "fK_ArtistId": 1,
        "instrumentName": "Udu.jpg",
        "instrumentDescription": "My Fav Udu",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 15,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 14,
        "fK_ArtistId": 1,
        "instrumentName": "FavAmp79_80.jpg",
        "instrumentDescription": "My Fav amp from 1979-80. Lab Series L5 The 100w 2x12. Lab Series L5. The Lab Series amplifiers were the result of a collaboration between Norlin companies, Gibson and Moog.",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 14,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 13,
        "fK_ArtistId": 1,
        "instrumentName": "IndianTampura.jpg",
        "instrumentDescription": "Indian Tampura",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 13,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 12,
        "fK_ArtistId": 1,
        "instrumentName": "FenderRhodes1973.jpg",
        "instrumentDescription": "1973 Fender Rhodes. Classic!",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 12,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 11,
        "fK_ArtistId": 1,
        "instrumentName": "PercsFlutesStuff.jpg",
        "instrumentDescription": "Percs, flutes and stuff",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 11,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 10,
        "fK_ArtistId": 1,
        "instrumentName": "KoraFromSenegal.jpg",
        "instrumentDescription": "Kora from Senegal",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 10,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 9,
        "fK_ArtistId": 1,
        "instrumentName": "IndianTabla.jpg",
        "instrumentDescription": "Indian tabla (small jembe)",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 9,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 8,
        "fK_ArtistId": 1,
        "instrumentName": "CraigKoenCustom Guitars.jpg",
        "instrumentDescription": "Custom Guitars from Craig Koen (master guitar maker from Port Lincoln, Australia)",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 8,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 7,
        "fK_ArtistId": 1,
        "instrumentName": "ChineseGuzgheng.jpg",
        "instrumentDescription": "Chinese Guzgheng ",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 7,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 6,
        "fK_ArtistId": 1,
        "instrumentName": "CeremonialTibetanSingingBowl.jpg",
        "instrumentDescription": "Ceremonial Tibetan Singing bowl",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 6,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 5,
        "fK_ArtistId": 1,
        "instrumentName": "BalafonBuzzMarimba.jpg",
        "instrumentDescription": "Balafon - Buzz Marimba",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 5,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 4,
        "fK_ArtistId": 1,
        "instrumentName": "XTSynth.jpg",
        "instrumentDescription": "Another killer synth, the XT",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 4,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 3,
        "fK_ArtistId": 1,
        "instrumentName": "KurtzweilSynth.jpg",
        "instrumentDescription": "A great synth from Kurtzweil",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 3,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 2,
        "fK_ArtistId": 1,
        "instrumentName": "OldSynth.jpg",
        "instrumentDescription": "A great fat sounding old synth.",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 2,
        "instrumentShow": true
      },
      {
        "pK_InstrumentId": 1,
        "fK_ArtistId": 1,
        "instrumentName": "CraigKoen.jpg",
        "instrumentDescription": "Two more beauties from Craig Koen",
        "instrumentStory": null,
        "instrumentDate": null,
        "instrumentSequence": 1,
        "instrumentShow": true
      }
    ],
    "artistLinks": [
      {
        "pK_LinkId": 22,
        "fK_ArtistId": 1,
        "linkSiteName": "NewAgeNotes",
        "linkUrl": "https://www.newagenotes.com/dino-pacifici-artist-page/?fbclid=IwAR0s4VxF7UiOaBCFIvgGq__R-Gd5yNdZ35xKbWHT2m9NxylIsop40U8ywkY",
        "linkLabel": "NewAgeNotes",
        "linkCategory": "Article",
        "linkIcon": null,
        "linkOrder": 0,
        "linkShow": true
      },
      {
        "pK_LinkId": 1,
        "fK_ArtistId": 1,
        "linkSiteName": "Bandcamp",
        "linkUrl": "https://dinopacifici.bandcamp.com/",
        "linkLabel": "BandCamp",
        "linkCategory": "Purchase",
        "linkIcon": "<i class='fa fa-bandcamp' aria-hidden='true'></i>",
        "linkOrder": 1,
        "linkShow": true
      },
      {
        "pK_LinkId": 5,
        "fK_ArtistId": 1,
        "linkSiteName": "Facebook",
        "linkUrl": "https://www.facebook.com/dee.pacifici",
        "linkLabel": "Facebook",
        "linkCategory": "Personal",
        "linkIcon": "<i class='fa-brands fa-facebook-f'></i>",
        "linkOrder": 1,
        "linkShow": true
      },
      {
        "pK_LinkId": 8,
        "fK_ArtistId": 1,
        "linkSiteName": "Discogs",
        "linkUrl": "https://www.discogs.com/artist/138849-Dino-Pacifici",
        "linkLabel": "Discogs",
        "linkCategory": "Purchase2",
        "linkIcon": null,
        "linkOrder": 1,
        "linkShow": true
      },
      {
        "pK_LinkId": 2,
        "fK_ArtistId": 1,
        "linkSiteName": "ITunes",
        "linkUrl": "https://music.apple.com/us/artist/dino-pacifici/4242046",
        "linkLabel": "iTunes",
        "linkCategory": "Purchase",
        "linkIcon": "<i class=\"fab fa-itunes'></i>",
        "linkOrder": 2,
        "linkShow": true
      },
      {
        "pK_LinkId": 23,
        "fK_ArtistId": 1,
        "linkSiteName": "YouTube",
        "linkUrl": "https://www.youtube.com/@dinopacificiofficial",
        "linkLabel": "YouTube",
        "linkCategory": "Personal",
        "linkIcon": null,
        "linkOrder": 2,
        "linkShow": true
      },
      {
        "pK_LinkId": 3,
        "fK_ArtistId": 1,
        "linkSiteName": "Spotify",
        "linkUrl": "https://open.spotify.com/artist/1d1D9Xk7ncEbTxOsOizhlZ",
        "linkLabel": "Spotify",
        "linkCategory": "Purchase",
        "linkIcon": "<i class='fa-brands fa-spotify'></i>",
        "linkOrder": 3,
        "linkShow": true
      },
      {
        "pK_LinkId": 6,
        "fK_ArtistId": 1,
        "linkSiteName": "Instagram",
        "linkUrl": "https://www.instagram.com/dinopacifici/",
        "linkLabel": "Instagram",
        "linkCategory": "Personal",
        "linkIcon": "<i class='fa-brands fa-instagram'></i>",
        "linkOrder": 3,
        "linkShow": true
      },
      {
        "pK_LinkId": 4,
        "fK_ArtistId": 1,
        "linkSiteName": "ReverbNation",
        "linkUrl": "https://www.reverbnation.com/dinopacifici",
        "linkLabel": "ReverbNation",
        "linkCategory": "Purchase",
        "linkIcon": null,
        "linkOrder": 4,
        "linkShow": true
      },
      {
        "pK_LinkId": 21,
        "fK_ArtistId": 1,
        "linkSiteName": "SoundCloud",
        "linkUrl": "https://soundcloud.com/dee-pacifici",
        "linkLabel": "SoundCloud",
        "linkCategory": "Purchase",
        "linkIcon": null,
        "linkOrder": 5,
        "linkShow": true
      },
      {
        "pK_LinkId": 9,
        "fK_ArtistId": 1,
        "linkSiteName": "Last.FM",
        "linkUrl": "https://www.last.fm/music/Dino+Pacifici",
        "linkLabel": "Last.FM",
        "linkCategory": "Article",
        "linkIcon": "<i class='fab fa-lastfm'></i>",
        "linkOrder": 9,
        "linkShow": true
      },
      {
        "pK_LinkId": 10,
        "fK_ArtistId": 1,
        "linkSiteName": "AllMusic",
        "linkUrl": "https://www.allmusic.com/artist/dino-pacifici-mn0000824656/discography?1691507831653",
        "linkLabel": "AllMusic",
        "linkCategory": "Purchase2",
        "linkIcon": null,
        "linkOrder": 9,
        "linkShow": true
      },
      {
        "pK_LinkId": 11,
        "fK_ArtistId": 1,
        "linkSiteName": "AmazonMusic",
        "linkUrl": "https://music.amazon.com/artists/B000QKJTFQ/dino-pacifici",
        "linkLabel": "AmazonMusic",
        "linkCategory": "Purchase2",
        "linkIcon": null,
        "linkOrder": 9,
        "linkShow": true
      },
      {
        "pK_LinkId": 12,
        "fK_ArtistId": 1,
        "linkSiteName": "CitizenFreak",
        "linkUrl": "https://citizenfreak.com/artists/108553-pacifici-dino",
        "linkLabel": "CitizenFreak",
        "linkCategory": "Article",
        "linkIcon": null,
        "linkOrder": 9,
        "linkShow": true
      },
      {
        "pK_LinkId": 13,
        "fK_ArtistId": 1,
        "linkSiteName": "AmbientVisions",
        "linkUrl": "http://www.ambientvisions.com/dinopacifici.htm",
        "linkLabel": "AmbientVisions",
        "linkCategory": "Article",
        "linkIcon": null,
        "linkOrder": 9,
        "linkShow": true
      },
      {
        "pK_LinkId": 14,
        "fK_ArtistId": 1,
        "linkSiteName": "Shazam",
        "linkUrl": "https://www.shazam.com/artist/dino-pacifici/4242046",
        "linkLabel": "Shazam",
        "linkCategory": "Purchase2",
        "linkIcon": null,
        "linkOrder": 9,
        "linkShow": true
      },
      {
        "pK_LinkId": 15,
        "fK_ArtistId": 1,
        "linkSiteName": "SoundClick",
        "linkUrl": "https://www.soundclick.com/artist/default.cfm?bandID=128840",
        "linkLabel": "SoundClick",
        "linkCategory": "Purchase2",
        "linkIcon": null,
        "linkOrder": 9,
        "linkShow": true
      },
      {
        "pK_LinkId": 16,
        "fK_ArtistId": 1,
        "linkSiteName": "PicFair",
        "linkUrl": "https://dinopacifici.picfair.com/",
        "linkLabel": "PicFair",
        "linkCategory": "Personal",
        "linkIcon": null,
        "linkOrder": 9,
        "linkShow": true
      },
      {
        "pK_LinkId": 18,
        "fK_ArtistId": 1,
        "linkSiteName": "SmoothJazz",
        "linkUrl": "http://www.smooth-jazz.de/Artists2/Pacifici.htm",
        "linkLabel": "SmoothJazz",
        "linkCategory": "Article",
        "linkIcon": null,
        "linkOrder": 9,
        "linkShow": true
      },
      {
        "pK_LinkId": 20,
        "fK_ArtistId": 1,
        "linkSiteName": "Wikipedia",
        "linkUrl": "https://en.wikipedia.org/wiki/Not_Just_the_Girl_Next_Door",
        "linkLabel": "Wikipedia",
        "linkCategory": "Article",
        "linkIcon": null,
        "linkOrder": 9,
        "linkShow": true
      }
    ]
  }

]